export const icons = [
	{ icon: '🌍', text: 'travel places - globe showing Europe-Africa earth כדור הארץ עולם' },
	{ icon: '🌎', text: 'travel places - globe showing Americas earth כדור הארץ עולם' },
	{ icon: '🌏', text: 'travel places - globe showing Asia-Australia earth כדור הארץ עולם' },
	{ icon: '🌐', text: 'travel places - globe with meridians language earth כדור הארץ עולם' },
	{ icon: '🗺', text: 'travel places - world map earth מפה' },
	{ icon: '🗾', text: 'travel places - map of Japan מפה' },
	{ icon: '🧭', text: 'travel places - compass clock שעון' },
	{ icon: '🏔', text: 'travel places - snow-capped mountain הר הרים הר view נופים' },
	{ icon: '⛰', text: 'travel places - mountain הר הרים הר view נופים' },
	{ icon: '🌋', text: 'travel places - volcano mountain הר הרים הר געש view נופים' },
	{ icon: '🗻', text: 'travel places - mount fuji mountain הר הרים הר view נופים' },
	{ icon: '🏕', text: 'travel places - camping קמפינג אוהל' },
	{ icon: '🏖', text: 'travel places - beach with umbrella ים חוף שמשייה מטריה' },
	{ icon: '🏜', text: 'travel places - desert מדבר view' },
	{ icon: '🏝', text: 'travel places - desert island חוף אי דקל' },
	{ icon: '🏞', text: 'travel places - national park פארק תמונה picture view' },
	{ icon: '🏟', text: 'travel places - stadium אצטדיון איצטדיון soccer football sport' },
	{ icon: '🏛', text: 'travel places - classical building מבנה בית מגדל תיירות tourist views' },
	{ icon: '🏗', text: 'travel places - building construction בנייה מבנה אתר' },
	{ icon: '🧱', text: 'travel places - brick rock אבן בנייה' },
	{ icon: '🏘', text: 'travel places - houses בית home city cities  בניין בניינים עיר ערים עיירות' },
	{ icon: '🏚', text: 'travel places - derelict house בית בתים home בניין בניינים' },
	{ icon: '🏠', text: 'travel places - house home בניין בניינים בית עיר ערים עיירות' },
	{ icon: '🏡', text: 'travel places - house with garden בית חצר עיר ערים עיירות בניין בניינים  home city' },
	{ icon: '🏢', text: 'travel places - office building city cities בניין בניינים עיר ערים עיירות מבנה' },
	{ icon: '🏣', text: 'travel places - Japanese post office מבנה בית בתים בניין בניינים home city cities' },
	{ icon: '🏤', text: 'travel places - post office city building house home עיר ערים עיירות בית בתים בניין בניינים' },
	{ icon: '🏥', text: 'travel places - hospital בית חולים sick' },
	{ icon: '🏦', text: 'travel places - bank בנק כסף money' },
	{ icon: '🏨', text: 'travel places - hotel בתי מלון בית מלון אירוח hostel resort' },
	{ icon: '🏩', text: 'travel places - love hotel בתי מלון בית מלון אירוח הוסטל hostel resort' },
	{ icon: '🏪', text: 'travel places - convenience store חנות נוחות shop shopping yellow' },
	{ icon: '🏫', text: 'travel places - school בית ספר' },
	{ icon: '🏬', text: 'travel places - department store חנות עיר ערים עיירות' },
	{ icon: '🏭', text: 'travel places - factory מפעל' },
	{ icon: '🏯', text: 'travel places - Japanese castle טירה נופים תיירות tourist' },
	{ icon: '🏰', text: 'travel places - castle טירה נופים תיירות tourist' },
	{ icon: '💒', text: 'travel places - wedding house building heart לב בית מבנה' },
	{ icon: '🗼', text: 'travel places - Tokyo tower tourist תיירות מבנה מגדל' },
	{ icon: '🗽', text: 'travel places - Statue of Liberty תיירות מגדל מבנה' },
	{ icon: '⛪', text: 'travel places - church תיירות נוצרי כנסייה tourist' },
	{ icon: '🕌', text: 'travel places - mosque tourist מסגד ערבי מוסלמי' },
	{ icon: '🛕', text: 'travel places - hindu temple מקדש הודי תיירות tourist' },
	{ icon: '🕍', text: 'travel places - synagogue תיירות tourist' },
	{ icon: '⛩', text: 'travel places - shinto shrine תיירות tourist' },
	{ icon: '🕋', text: 'travel places - kaaba תיירות tourist' },
	{ icon: '⛲', text: 'travel places - fountain tourist מזרקה נופים תיירות מים' },
	{ icon: '⛺', text: 'travel places - tent אוהל' },
	{ icon: '🌁', text: 'travel places - foggy ערפל נופים views' },
	{ icon: '🌃', text: 'travel places - night with stars city cities עיר ערים עיירות' },
	{ icon: '🏙', text: 'travel places - cityscape city cities עיר ערים עיירות views' },
	{ icon: '🌄', text: 'travel places - sunrise over mountain הר הריםs views נופים' },
	{ icon: '🌅', text: 'travel places - sunrise זריחה נופים views' },
	{ icon: '🌆', text: 'travel places - cityscape at dusk city cities עיר ערים עיירות זריחה נופים views' },
	{ icon: '🌇', text: 'travel places - sunset city cities עיר ערים עיירות זריחה נופים views' },
	{ icon: '🌉', text: 'travel places - bridge at night city cities עיר ערים עיירות נופים views' },
	{ icon: '♨', text: 'travel places - hot springs חם' },
	{ icon: '🎠', text: 'travel places - carousel horse סוס animal tourist attraction' },
	{ icon: '🎡', text: 'travel places - ferris wheel attraction אטרקציות' },
	{ icon: '🎢', text: 'travel places - roller coaster attraction אטרקציות' },
	{ icon: '💈', text: 'travel places - barber pole' },
	{ icon: '🎪', text: 'travel places - circus tent attraction אטרקציות אוהל' },
	{ icon: '🚂', text: 'travel places - locomotive' },
	{ icon: '🚃', text: 'travel places - railway car' },
	{ icon: '🚄', text: 'travel places - high-speed train רכבת רכבות' },
	{ icon: '🚅', text: 'travel places - bullet train רכבת רכבות' },
	{ icon: '🚆', text: 'travel places - train רכבת רכבות' },
	{ icon: '🚇', text: 'travel places - metro רכבת רכבות' },
	{ icon: '🚈', text: 'travel places - light rail רכבת רכבות' },
	{ icon: '🚉', text: 'travel places - station רכבת רכבות' },
	{ icon: '🚊', text: 'travel places - tram רכבת רכבות' },
	{ icon: '🚝', text: 'travel places - monorail רכבת רכבות' },
	{ icon: '🚞', text: 'travel places - mountain הר הרים railway רכבת רכבות' },
	{ icon: '🚋', text: 'travel places - tram car' },
	{ icon: '🚌', text: 'travel places - bus' },
	{ icon: '🚍', text: 'travel places - oncoming bus' },
	{ icon: '🚎', text: 'travel places - trolleybus car driving מכונית רכב אוטו נסיעה לנסוע הגה' },
	{ icon: '🚐', text: 'travel places - minibus car driving מכונית רכב אוטו נסיעה לנסוע הגה' },
	{ icon: '🚑', text: 'travel places - ambulance car בית חולים אמבולנס driving מכונית רכב אוטו נסיעה לנסוע הגה' },
	{ icon: '🚒', text: 'travel places - fire engine car כבאית driving מכונית רכב אוטו נסיעה לנסוע הגה' },
	{ icon: '🚓', text: 'travel places - police car car driving מכונית רכב אוטו נסיעה לנסוע הגה' },
	{ icon: '🚔', text: 'travel places - oncoming משטרה police car car driving מכונית רכב אוטו נסיעה לנסוע הגה' },
	{ icon: '🚕', text: 'travel places - taxi car driving מכונית רכב אוטו נסיעה לנסוע הגה' },
	{ icon: '🚖', text: 'travel places - oncoming taxi car driving מכונית רכב אוטו נסיעה לנסוע הגה' },
	{ icon: '🚗', text: 'travel places - automobile car driving מכונית רכב אוטו נסיעה לנסוע הגה' },
	{ icon: '🚘', text: 'travel places - oncoming automobile car driving מכונית רכב אוטו נסיעה לנסוע הגה' },
	{ icon: '🚙', text: 'travel places - sport utility vehicle car driving מכונית רכב אוטו נסיעה לנסוע הגה' },
	{ icon: '🚚', text: 'travel places - delivery truck car driving מכונית רכב אוטו נסיעה לנסוע הגה' },
	{ icon: '🚛', text: 'travel places - articulated lorry car driving מכונית רכב אוטו נסיעה לנסוע הגה' },
	{ icon: '🚜', text: 'travel places - tractor car driving מכונית רכב אוטו נסיעה לנסוע הגה' },
	{ icon: '🏎', text: 'travel places - racing car driving מכונית רכב אוטו נסיעה לנסוע הגה race' },
	{ icon: '🏍', text: 'travel places - motorcycle car driving מכונית רכב אוטו נסיעה לנסוע הגה אופנוי קטנוע' },
	{ icon: '🛵', text: 'travel places - motor scooter אופנוע קטנוע  car driving מכונית רכב אוטו נסיעה לנסוע הגה' },
	{ icon: '🦽', text: 'travel places - manual wheelchair כסא גלגלים כיסא גלגלים נכה מוגבלות' },
	{ icon: '🦼', text: 'travel places - motorized wheelchair כסא גלגלים כיסא גלגלים נכה מוגבלות' },
	{ icon: '🛺', text: 'travel places - auto rickshaw טוקטוק  car driving מכונית רכב אוטו נסיעה לנסוע הגה' },
	{
		icon: '🚲',
		text: 'travel places - bicycle אופניים רכיבה לנסוע לרכב  car driving מכונית רכב אוטו נסיעה לנסוע הגה tel aviv אופנים',
	},
	{ icon: '🛴', text: 'travel places - kick scooter קורקינט תל אביב tel aviv' },
	{ icon: '🛹', text: 'travel places - skateboard' },
	{ icon: '🚏', text: 'travel places - bus stop' },
	{ icon: '🛣', text: 'travel places - motorway' },
	{ icon: '🛤', text: 'travel places - railway track שביל כביש דרך דרכים טבע תיירות' },
	{ icon: '🛢', text: 'travel places - oil drum' },
	{ icon: '⛽', text: 'travel places - fuel pump' },
	{
		icon: '🚨',
		text: 'travel places - police car light important hot start must most חשוב חייב חובה סירנה משטרה אדום',
	},
	{ icon: '🚥', text: 'travel places - horizontal traffic light' },
	{ icon: '🚦', text: 'travel places - vertical traffic light' },
	{ icon: '🛑', text: 'travel places - stop sign' },
	{ icon: '🚧', text: 'travel places - construction' },
	{ icon: '⚓', text: 'travel places - anchor sea lake water general ים אגם נהר נהרות אגמים שייט ים' },
	{ icon: '⛵', text: 'travel places - sailboat הפלגה נהר נהרות אגם אגמים שייט שיט ים' },
	{ icon: '🛶', text: 'travel places - canoe lake boat אגם נהר נהרות אגמים שייט שיט ים' },
	{ icon: '🚤', text: 'travel places - speedboat boat אגם אגמים ים שייט שיר נהר נהרות סירה סירות' },
	{ icon: '🛳', text: 'travel places - passenger ship boat סירה סירות אגם שייט הפלגה שיט' },
	{ icon: '⛴', text: 'travel places - ferry boat סירה סירות אגם שייט הפלגה שיט' },
	{ icon: '🛥', text: 'travel places - motor boat סירה סירות אגם שייט הפלגה שיט' },
	{ icon: '🚢', text: 'travel places - ship boat סירה סירות אגם שייט הפלגה שיט' },
	{ icon: '✈', text: 'travel places - airplane מטוס טיסות' },
	{ icon: '🛩', text: 'travel places - flight small airplane מטוס טיסות' },
	{ icon: '🛫', text: 'travel places - flight airplane מטוס טיסות departure' },
	{ icon: '🛬', text: 'travel places - flight airplane מטוס טיסות arrival' },
	{ icon: '🪂', text: 'travel places - parachute attraction אטרקציות' },
	{ icon: '💺', text: 'travel places - seat' },
	{ icon: '🚁', text: 'travel places - helicopter' },
	{ icon: '🚟', text: 'travel places - suspension railway' },
	{ icon: '🚠', text: 'travel places - mountain הר הרים cableway' },
	{ icon: '🚡', text: 'travel places - aerial tramway' },
	{ icon: '🛰', text: 'travel places - satellite' },
	{ icon: '🚀', text: 'travel places - rocket' },
	{ icon: '🛸', text: 'travel places - flying saucer' },
	{ icon: '🛎', text: 'travel places - bellhop bell' },
	{ icon: '🧳', text: 'travel places - luggage' },
	{ icon: '⌛', text: 'travel places - hourglass done' },
	{ icon: '⏳', text: 'travel places - hourglass not done' },
	{ icon: '⌚', text: 'travel places - watch' },
	{ icon: '⏰', text: 'travel places - alarm clock' },
	{ icon: '⏱', text: 'travel places - stopwatch' },
	{ icon: '⏲', text: 'travel places - timer clock' },
	{ icon: '🕰', text: 'travel places - mantelpiece clock' },
	{ icon: '🕛', text: 'travel places - twelve o’clock' },
	{ icon: '🕧', text: 'travel places - twelve-thirty' },
	{ icon: '🕐', text: 'travel places - one o’clock' },
	{ icon: '🕜', text: 'travel places - one-thirty' },
	{ icon: '🕑', text: 'travel places - two o’clock' },
	{ icon: '🕝', text: 'travel places - two-thirty' },
	{ icon: '🕒', text: 'travel places - three o’clock' },
	{ icon: '🕞', text: 'travel places - three-thirty' },
	{ icon: '🕓', text: 'travel places - four o’clock' },
	{ icon: '🕟', text: 'travel places - four-thirty' },
	{ icon: '🕔', text: 'travel places - five o’clock' },
	{ icon: '🕠', text: 'travel places - five-thirty' },
	{ icon: '🕕', text: 'travel places - six o’clock' },
	{ icon: '🕡', text: 'travel places - six-thirty' },
	{ icon: '🕖', text: 'travel places - seven o’clock' },
	{ icon: '🕢', text: 'travel places - seven-thirty' },
	{ icon: '🕗', text: 'travel places - eight o’clock' },
	{ icon: '🕣', text: 'travel places - eight-thirty' },
	{ icon: '🕘', text: 'travel places - nine o’clock' },
	{ icon: '🕤', text: 'travel places - nine-thirty' },
	{ icon: '🕙', text: 'travel places - ten o’clock' },
	{ icon: '🕥', text: 'travel places - ten-thirty' },
	{ icon: '🕚', text: 'travel places - eleven o’clock' },
	{ icon: '🕦', text: 'travel places - eleven-thirty' },
	{ icon: '🌑', text: 'travel places - new moon' },
	{ icon: '🌒', text: 'travel places - waxing crescent moon' },
	{ icon: '🌓', text: 'travel places - first quarter moon' },
	{ icon: '🌔', text: 'travel places - waxing gibbous moon' },
	{ icon: '🌕', text: 'travel places - full moon' },
	{ icon: '🌖', text: 'travel places - waning gibbous moon' },
	{ icon: '🌗', text: 'travel places - last quarter moon' },
	{ icon: '🌘', text: 'travel places - waning crescent moon' },
	{ icon: '🌙', text: 'travel places - crescent moon' },
	{ icon: '🌚', text: 'travel places - new moon face' },
	{ icon: '🌛', text: 'travel places - first quarter moon face' },
	{ icon: '🌜', text: 'travel places - last quarter moon face' },
	{ icon: '🌡', text: 'travel places - thermometer' },
	{ icon: '☀', text: 'travel places - sun שמש' },
	{ icon: '🌝', text: 'travel places - full moon face' },
	{ icon: '🌞', text: 'travel places - sun with face' },
	{ icon: '🪐', text: 'travel places - ringed planet' },
	{ icon: '⭐', text: 'travel places - star attraction כוכב אטרקציות' },
	{ icon: '🌟', text: 'travel places - glowing star attraction כוכב זוהר אטרקציות' },
	{ icon: '🌠', text: 'travel places - shooting star כוכב' },
	{ icon: '🌌', text: 'travel places - milky way זוהר' },
	{ icon: '☁', text: 'travel places - cloud' },
	{ icon: '⛅', text: 'travel places - sun behind cloud' },
	{ icon: '⛈', text: 'travel places - cloud with lightning and rain' },
	{ icon: '🌤', text: 'travel places - sun behind small cloud' },
	{ icon: '🌥', text: 'travel places - sun behind large cloud' },
	{ icon: '🌦', text: 'travel places - sun behind rain cloud' },
	{ icon: '🌧', text: 'travel places - cloud with rain' },
	{ icon: '🌨', text: 'travel places - cloud with snow' },
	{ icon: '🌩', text: 'travel places - cloud with lightning' },
	{ icon: '🌪', text: 'travel places - tornado' },
	{ icon: '🌫', text: 'travel places - fog' },
	{ icon: '🌬', text: 'travel places - wind face' },
	{ icon: '🌀', text: 'travel places - cyclone' },
	{ icon: '🌈', text: 'travel places - rainbow' },
	{ icon: '🌂', text: 'travel places - closed umbrella' },
	{ icon: '☂', text: 'travel places - umbrella' },
	{ icon: '☔', text: 'travel places - umbrella with rain drops' },
	{ icon: '⛱', text: 'travel places - umbrella on ground' },
	{ icon: '⚡', text: 'travel places - high voltage חובה ברק צהוב' },
	{ icon: '❄', text: 'travel places - snowflake' },
	{ icon: '☃', text: 'travel places - snowman' },
	{ icon: '⛄', text: 'travel places - snowman without snow' },
	{ icon: '☄', text: 'travel places - comet' },
	{ icon: '🔥', text: 'travel places - fire אש חובה' },
	{ icon: '💧', text: 'travel places - droplet ים מים אגמים נהרות' },
	{ icon: '🌊', text: 'travel places - water wave lake sea ים אגמים חופים נהרות' },
	{ icon: '😀', text: 'smiley emoji emotion - סמיילי grinning face' },
	{ icon: '😃', text: 'smiley emoji emotion - סמיילי grinning face with big eyes' },
	{ icon: '😄', text: 'smiley emoji emotion - סמיילי grinning face with smiling eyes' },
	{ icon: '😁', text: 'smiley emoji emotion - סמיילי beaming face with smiling eyes' },
	{ icon: '😆', text: 'smiley emoji emotion - סמיילי grinning squinting face' },
	{ icon: '😅', text: 'smiley emoji emotion - סמיילי grinning face with sweat' },
	{ icon: '🤣', text: 'smiley emoji emotion - סמיילי rolling on the floor laughing' },
	{ icon: '😂', text: 'smiley emoji emotion - סמיילי face with tears of joy' },
	{ icon: '🙂', text: 'smiley emoji emotion - סמיילי slightly smiling face' },
	{ icon: '🙃', text: 'smiley emoji emotion - סמיילי upside-down face' },
	{ icon: '😉', text: 'smiley emoji emotion - סמיילי winking face' },
	{ icon: '😊', text: 'smiley emoji emotion - סמיילי smiling face with smiling eyes' },
	{ icon: '😇', text: 'smiley emoji emotion - סמיילי smiling face with halo' },
	{ icon: '🥰', text: 'smiley emoji emotion - סמיילי smiling face with hearts' },
	{ icon: '😍', text: 'smiley emoji emotion - סמיילי smiling face with heart-eyes' },
	{ icon: '🤩', text: 'smiley emoji emotion - סמיילי star-struck' },
	{ icon: '😘', text: 'smiley emoji emotion - סמיילי face blowing a kiss' },
	{ icon: '😗', text: 'smiley emoji emotion - סמיילי kissing face' },
	{ icon: '☺', text: 'smiley emoji emotion - סמיילי smiling face' },
	{ icon: '😚', text: 'smiley emoji emotion - סמיילי kissing face with closed eyes' },
	{ icon: '😙', text: 'smiley emoji emotion - סמיילי kissing face with smiling eyes' },
	{ icon: '😋', text: 'smiley emoji emotion - סמיילי face savoring food' },
	{ icon: '😛', text: 'smiley emoji emotion - סמיילי face with tongue' },
	{ icon: '😜', text: 'smiley emoji emotion - סמיילי winking face with tongue' },
	{ icon: '🤪', text: 'smiley emoji emotion - סמיילי zany face' },
	{ icon: '😝', text: 'smiley emoji emotion - סמיילי squinting face with tongue' },
	{ icon: '🤑', text: 'smiley emoji emotion - סמיילי money-mouth face' },
	{ icon: '🤗', text: 'smiley emoji emotion - סמיילי hugging face' },
	{ icon: '🤭', text: 'smiley emoji emotion - סמיילי face with hand over mouth' },
	{ icon: '🤫', text: 'smiley emoji emotion - סמיילי shushing face' },
	{ icon: '🤔', text: 'smiley emoji emotion - סמיילי thinking face' },
	{ icon: '🤐', text: 'smiley emoji emotion - סמיילי zipper-mouth face' },
	{ icon: '🤨', text: 'smiley emoji emotion - סמיילי face with raised eyebrow' },
	{ icon: '😐', text: 'smiley emoji emotion - סמיילי neutral face' },
	{ icon: '😑', text: 'smiley emoji emotion - סמיילי expressionless face' },
	{ icon: '😶', text: 'smiley emoji emotion - סמיילי face without mouth' },
	{ icon: '😏', text: 'smiley emoji emotion - סמיילי smirking face' },
	{ icon: '😒', text: 'smiley emoji emotion - סמיילי unamused face' },
	{ icon: '🙄', text: 'smiley emoji emotion - סמיילי face with rolling eyes' },
	{ icon: '😬', text: 'smiley emoji emotion - סמיילי grimacing face' },
	{ icon: '🤥', text: 'smiley emoji emotion - סמיילי lying face' },
	{ icon: '😌', text: 'smiley emoji emotion - סמיילי relieved face' },
	{ icon: '😔', text: 'smiley emoji emotion - סמיילי pensive face' },
	{ icon: '😪', text: 'smiley emoji emotion - סמיילי sleepy face' },
	{ icon: '🤤', text: 'smiley emoji emotion - סמיילי drooling face' },
	{ icon: '😴', text: 'smiley emoji emotion - סמיילי sleeping face' },
	{ icon: '😷', text: 'smiley emoji emotion - סמיילי face with medical mask' },
	{ icon: '🤒', text: 'smiley emoji emotion - סמיילי face with thermometer' },
	{ icon: '🤕', text: 'smiley emoji emotion - סמיילי face with head-bandage' },
	{ icon: '🤢', text: 'smiley emoji emotion - סמיילי nauseated face' },
	{ icon: '🤮', text: 'smiley emoji emotion - סמיילי face vomiting' },
	{ icon: '🤧', text: 'smiley emoji emotion - סמיילי sneezing face' },
	{ icon: '🥵', text: 'smiley emoji emotion - סמיילי hot face' },
	{ icon: '🥶', text: 'smiley emoji emotion - סמיילי cold face' },
	{ icon: '🥴', text: 'smiley emoji emotion - סמיילי woozy face' },
	{ icon: '😵', text: 'smiley emoji emotion - סמיילי dizzy face' },
	{ icon: '🤯', text: 'smiley emoji emotion - סמיילי exploding head' },
	{ icon: '🤠', text: 'smiley emoji emotion - סמיילי cowboy hat face' },
	{ icon: '🥳', text: 'smiley emoji emotion - סמיילי partying face' },
	{ icon: '😎', text: 'smiley emoji emotion - סמיילי smiling face with sunglasses' },
	{ icon: '🤓', text: 'smiley emoji emotion - סמיילי nerd face' },
	{ icon: '🧐', text: 'smiley emoji emotion - סמיילי face with monocle' },
	{ icon: '😕', text: 'smiley emoji emotion - סמיילי confused face' },
	{ icon: '😟', text: 'smiley emoji emotion - סמיילי worried face' },
	{ icon: '🙁', text: 'smiley emoji emotion - סמיילי slightly frowning face' },
	{ icon: '☹', text: 'smiley emoji emotion - סמיילי frowning face' },
	{ icon: '😮', text: 'smiley emoji emotion - סמיילי face with open mouth' },
	{ icon: '😯', text: 'smiley emoji emotion - סמיילי hushed face' },
	{ icon: '😲', text: 'smiley emoji emotion - סמיילי astonished face' },
	{ icon: '😳', text: 'smiley emoji emotion - סמיילי flushed face' },
	{ icon: '🥺', text: 'smiley emoji emotion - סמיילי pleading face' },
	{ icon: '😦', text: 'smiley emoji emotion - סמיילי frowning face with open mouth' },
	{ icon: '😧', text: 'smiley emoji emotion - סמיילי anguished face' },
	{ icon: '😨', text: 'smiley emoji emotion - סמיילי fearful face' },
	{ icon: '😰', text: 'smiley emoji emotion - סמיילי anxious face with sweat' },
	{ icon: '😥', text: 'smiley emoji emotion - סמיילי sad but relieved face' },
	{ icon: '😢', text: 'smiley emoji emotion - סמיילי crying face' },
	{ icon: '😭', text: 'smiley emoji emotion - סמיילי loudly crying face' },
	{ icon: '😱', text: 'smiley emoji emotion - סמיילי face screaming in fear' },
	{ icon: '😖', text: 'smiley emoji emotion - סמיילי confounded face' },
	{ icon: '😣', text: 'smiley emoji emotion - סמיילי persevering face' },
	{ icon: '😞', text: 'smiley emoji emotion - סמיילי disappointed face' },
	{ icon: '😓', text: 'smiley emoji emotion - סמיילי downcast face with sweat' },
	{ icon: '😩', text: 'smiley emoji emotion - סמיילי weary face' },
	{ icon: '😫', text: 'smiley emoji emotion - סמיילי tired face' },
	{ icon: '🥱', text: 'smiley emoji emotion - סמיילי yawning face' },
	{ icon: '😤', text: 'smiley emoji emotion - סמיילי face with steam from nose' },
	{ icon: '😡', text: 'smiley emoji emotion - סמיילי pouting face' },
	{ icon: '😠', text: 'smiley emoji emotion - סמיילי angry face' },
	{ icon: '🤬', text: 'smiley emoji emotion - סמיילי face with symbols on mouth' },
	{ icon: '😈', text: 'smiley emoji emotion - סמיילי smiling face with horns' },
	{ icon: '👿', text: 'smiley emoji emotion - סמיילי angry face with horns' },
	{ icon: '💀', text: 'smiley emoji emotion - סמיילי skull' },
	{ icon: '☠', text: 'smiley emoji emotion - סמיילי skull and crossbones' },
	{ icon: '💩', text: 'smiley emoji emotion - סמיילי pile of poo' },
	{ icon: '🤡', text: 'smiley emoji emotion - סמיילי clown face' },
	{ icon: '👹', text: 'smiley emoji emotion - סמיילי ogre' },
	{ icon: '👺', text: 'smiley emoji emotion - סמיילי goblin' },
	{ icon: '👻', text: 'smiley emoji emotion - סמיילי ghost boo gimmicks גימיקים שטויות' },
	{ icon: '👽', text: 'smiley emoji emotion - סמיילי alien' },
	{ icon: '👾', text: 'smiley emoji emotion - סמיילי alien monster' },
	{ icon: '🤖', text: 'smiley emoji emotion - סמיילי robot' },
	{ icon: '😺', text: 'smiley emoji emotion - סמיילי grinning cat' },
	{ icon: '😸', text: 'smiley emoji emotion - סמיילי grinning cat with smiling eyes' },
	{ icon: '😹', text: 'smiley emoji emotion - סמיילי cat with tears of joy' },
	{ icon: '😻', text: 'smiley emoji emotion - סמיילי smiling cat with heart-eyes' },
	{ icon: '😼', text: 'smiley emoji emotion - סמיילי cat with wry smile' },
	{ icon: '😽', text: 'smiley emoji emotion - סמיילי kissing cat' },
	{ icon: '🙀', text: 'smiley emoji emotion - סמיילי weary cat' },
	{ icon: '😿', text: 'smiley emoji emotion - סמיילי crying cat' },
	{ icon: '😾', text: 'smiley emoji emotion - סמיילי pouting cat' },
	{ icon: '🙈', text: 'smiley emoji emotion - סמיילי see-no-evil monkey' },
	{ icon: '🙉', text: 'smiley emoji emotion - סמיילי hear-no-evil monkey' },
	{ icon: '🙊', text: 'smiley emoji emotion - סמיילי speak-no-evil monkey' },
	{ icon: '💋', text: 'smiley emoji emotion - סמיילי kiss mark' },
	{ icon: '💌', text: 'smiley emoji emotion - סמיילי love letter' },
	{ icon: '💘', text: 'smiley emoji emotion - סמיילי לב heart with arrow' },
	{ icon: '💝', text: 'smiley emoji emotion - סמיילי לב heart with ribbon' },
	{ icon: '💖', text: 'smiley emoji emotion - סמיילי לב מוזהב sparkling heart' },
	{ icon: '💗', text: 'smiley emoji emotion - סמיילי לב growing heart' },
	{ icon: '💓', text: 'smiley emoji emotion - סמיילי לב beating heart לב' },
	{ icon: '💞', text: 'smiley emoji emotion - סמיילי לב revolving hearts' },
	{ icon: '💕', text: 'smiley emoji emotion - סמיילי לבבות two hearts' },
	{ icon: '💟', text: 'smiley emoji emotion - סמיילי לב heart decoration' },
	{ icon: '❣', text: 'smiley emoji emotion - סמיילי לב heart exclamation' },
	{ icon: '💔', text: 'smiley emoji emotion - סמיילי לב broken heart' },
	{ icon: '❤', text: 'smiley emoji emotion - סמיילי לב red heart' },
	{ icon: '🧡', text: 'smiley emoji emotion - סמיילי לב orange heart' },
	{ icon: '💛', text: 'smiley emoji emotion royal gold רויאל מלכותי זהב - סמיילי לב yellow heart' },
	{ icon: '💚', text: 'smiley emoji emotion - סמיילי לב green heart' },
	{ icon: '💙', text: 'smiley emoji emotion - סמיילי לב blue heart' },
	{ icon: '💜', text: 'smiley emoji emotion - סמיילי לב purple heart' },
	{ icon: '🤎', text: 'smiley emoji emotion - סמיילי לב brown heart' },
	{ icon: '🖤', text: 'smiley emoji emotion - סמיילי לב black heart' },
	{ icon: '🤍', text: 'smiley emoji emotion - סמיילי לב white heart' },
	{ icon: '💯', text: 'smiley emoji emotion - סמיילי hundred points' },
	{ icon: '💢', text: 'smiley emoji emotion - סמיילי anger symbol' },
	{ icon: '💥', text: 'smiley emoji emotion - סמיילי collision' },
	{ icon: '💫', text: 'smiley emoji emotion - סמיילי dizzy' },
	{ icon: '💦', text: 'smiley emoji emotion - סמיילי sweat droplets' },
	{ icon: '💨', text: 'smiley emoji emotion - סמיילי dashing away' },
	{ icon: '🕳', text: 'smiley emoji emotion - סמיילי hole' },
	{ icon: '💣', text: 'smiley emoji emotion - סמיילי bomb' },
	{ icon: '💬', text: 'smiley emoji emotion - סמיילי speech balloon' },
	{ icon: '👁️', text: 'smiley emoji emotion - סמיילי eye in speech bubble' },
	{ icon: '🗨', text: 'smiley emoji emotion - סמיילי left speech bubble' },
	{ icon: '🗯', text: 'smiley emoji emotion - סמיילי right anger bubble' },
	{ icon: '💭', text: 'smiley emoji emotion - סמיילי thought balloon' },
	{ icon: '💤', text: 'smiley emoji emotion - סמיילי zzz ישן עייף מעייף' },
	{ icon: '👋', text: 'people body - waving hand' },
	{ icon: '🤚', text: 'people body - raised back of hand' },
	{ icon: '🖐', text: 'people body - hand with fingers splayed' },
	{ icon: '✋', text: 'people body - raised hand' },
	{ icon: '🖖', text: 'people body - vulcan salute' },
	{ icon: '👌', text: 'people body - OK hand' },
	{ icon: '🤏', text: 'people body - pinching hand' },
	{ icon: '✌', text: 'people body - victory hand' },
	{ icon: '🤞', text: 'people body - crossed fingers' },
	{ icon: '🤟', text: 'people body - love-you gesture' },
	{ icon: '🤘', text: 'people body - sign of the horns' },
	{ icon: '🤙', text: 'people body - call me hand' },
	{ icon: '👈', text: 'people body - backhand index pointing left' },
	{ icon: '👉', text: 'people body - backhand index pointing right' },
	{ icon: '👆', text: 'people body - backhand index pointing up' },
	{ icon: '🖕', text: 'people body - middle finger' },
	{ icon: '👇', text: 'people body - backhand index pointing down' },
	{ icon: '☝', text: 'people body - index pointing up' },
	{ icon: '👍', text: 'people body - thumbs up' },
	{ icon: '👎', text: 'people body - thumbs down' },
	{ icon: '✊', text: 'people body - raised fist' },
	{ icon: '👊', text: 'people body - oncoming fist' },
	{ icon: '🤛', text: 'people body - left-facing fist' },
	{ icon: '🤜', text: 'people body - right-facing fist' },
	{ icon: '👏', text: 'people body - clapping hands' },
	{ icon: '🙌', text: 'people body - raising hands' },
	{ icon: '👐', text: 'people body - open hands' },
	{ icon: '🤲', text: 'people body - palms up together' },
	{ icon: '🤝', text: 'people body - handshake' },
	{ icon: '🙏', text: 'people body - folded hands' },
	{ icon: '✍', text: 'people body - writing hand' },
	{ icon: '💅', text: 'people body - nail polish finger' },
	{ icon: '🤳', text: 'people body - selfie phone' },
	{ icon: '💪', text: 'people body - flexed biceps strong gym' },
	{ icon: '🦾', text: 'people body - mechanical arm strong gym' },
	{ icon: '🦿', text: 'people body - mechanical leg strong gym' },
	{ icon: '🦵', text: 'people body - leg' },
	{ icon: '🦶', text: 'people body - foot' },
	{ icon: '👂', text: 'people body - ear' },
	{ icon: '🦻', text: 'people body - ear with hearing aid' },
	{ icon: '👃', text: 'people body - nose' },
	{ icon: '🧠', text: 'people body - brain' },
	{ icon: '🦷', text: 'people body - tooth' },
	{ icon: '🦴', text: 'people body - bone' },
	{ icon: '👀', text: 'people body - eyes' },
	{ icon: '👁', text: 'people body - eye' },
	{ icon: '👅', text: 'people body - tongue' },
	{ icon: '👄', text: 'people body - mouth' },
	{ icon: '👶', text: 'people body - baby' },
	{ icon: '🧒', text: 'people body - child' },
	{ icon: '👦', text: 'people body - boy' },
	{ icon: '👧', text: 'people body - girl' },
	{ icon: '🧑', text: 'people body - person' },
	{ icon: '👱', text: 'people body - person: blond hair' },
	{ icon: '👨', text: 'people body - man' },
	{ icon: '🧔', text: 'people body - man: beard' },
	{ icon: '👱‍♂️', text: 'people body - man: blond hair' },
	{ icon: '👨‍🦰', text: 'people body - man: red hair' },
	{ icon: '👨‍🦱', text: 'people body - man: curly hair' },
	{ icon: '👨‍🦳', text: 'people body - man: white hair' },
	{ icon: '👨‍🦲', text: 'people body - man: bald' },
	{ icon: '👩', text: 'people body - woman' },
	{ icon: '👱‍♀️', text: 'people body - woman: blond hair' },
	{ icon: '👩‍🦰', text: 'people body - woman: red hair' },
	{ icon: '👩‍🦱', text: 'people body - woman: curly hair' },
	{ icon: '👩‍🦳', text: 'people body - woman: white hair' },
	{ icon: '👩‍🦲', text: 'people body - woman: bald' },
	{ icon: '🧓', text: 'people body - older person' },
	{ icon: '👴', text: 'people body - old man' },
	{ icon: '👵', text: 'people body - old woman' },
	{ icon: '🙍', text: 'people body - person frowning' },
	{ icon: '🙍‍♂️', text: 'people body - man frowning' },
	{ icon: '🙍‍♀️', text: 'people body - woman frowning' },
	{ icon: '🙎', text: 'people body - person pouting' },
	{ icon: '🙎‍♂️', text: 'people body - man pouting' },
	{ icon: '🙎‍♀️', text: 'people body - woman pouting' },
	{ icon: '🙅', text: 'people body - person gesturing NO' },
	{ icon: '🙅‍♂️', text: 'people body - man gesturing NO' },
	{ icon: '🙅‍♀️', text: 'people body - woman gesturing NO' },
	{ icon: '🙆', text: 'people body - person gesturing OK' },
	{ icon: '🙆‍♂️', text: 'people body - man gesturing OK' },
	{ icon: '🙆‍♀️', text: 'people body - woman gesturing OK' },
	{ icon: '💁', text: 'people body - person tipping hand' },
	{ icon: '💁‍♂️', text: 'people body - man tipping hand' },
	{ icon: '💁‍♀️', text: 'people body - woman tipping hand' },
	{ icon: '🙋', text: 'people body - person raising hand' },
	{ icon: '🙋‍♂️', text: 'people body - man raising hand' },
	{ icon: '🙋‍♀️', text: 'people body - woman raising hand' },
	{ icon: '🧏', text: 'people body - deaf person' },
	{ icon: '🧏‍♂️', text: 'people body - deaf man' },
	{ icon: '🧏‍♀️', text: 'people body - deaf woman' },
	{ icon: '🙇', text: 'people body - person bowing' },
	{ icon: '🙇‍♂️', text: 'people body - man bowing' },
	{ icon: '🙇‍♀️', text: 'people body - woman bowing' },
	{ icon: '🤦', text: 'people body - person facepalming face bump' },
	{ icon: '🤦‍♂️', text: 'people body - man facepalming face bump' },
	{ icon: '🤦‍♀️', text: 'people body - woman facepalming face bump' },
	{ icon: '🤷', text: 'people body - person shrugging idk' },
	{ icon: '🤷‍♂️', text: 'people body - man shrugging idk' },
	{ icon: '🤷‍♀️', text: 'people body - woman shrugging idk' },
	{ icon: '👨‍⚕️', text: 'people body - man health worker' },
	{ icon: '👩‍⚕️', text: 'people body - woman health worker' },
	{ icon: '👨‍🎓', text: 'people body - man student' },
	{ icon: '👩‍🎓', text: 'people body - woman student' },
	{ icon: '👨‍🏫', text: 'people body - man teacher' },
	{ icon: '👩‍🏫', text: 'people body - woman teacher' },
	{ icon: '👨‍⚖️', text: 'people body - man judge' },
	{ icon: '👩‍⚖️', text: 'people body - woman judge' },
	{ icon: '👨‍🌾', text: 'people body - man farmer' },
	{ icon: '👩‍🌾', text: 'people body - woman farmer' },
	{ icon: '👨‍🍳', text: 'people body - man cook' },
	{ icon: '👩‍🍳', text: 'people body - woman cook' },
	{ icon: '👨‍🔧', text: 'people body - man mechanic' },
	{ icon: '👩‍🔧', text: 'people body - woman mechanic' },
	{ icon: '👨‍🏭', text: 'people body - man factory worker' },
	{ icon: '👩‍🏭', text: 'people body - woman factory worker' },
	{ icon: '👨‍💼', text: 'people body - man office worker' },
	{ icon: '👩‍💼', text: 'people body - woman office worker' },
	{ icon: '👨‍🔬', text: 'people body - man scientist' },
	{ icon: '👩‍🔬', text: 'people body - woman scientist' },
	{ icon: '👨‍💻', text: 'people body - man technologist' },
	{ icon: '👩‍💻', text: 'people body - woman technologist' },
	{ icon: '👨‍🎤', text: 'people body - man singer' },
	{ icon: '👩‍🎤', text: 'people body - woman singer' },
	{ icon: '👨‍🎨', text: 'people body - man artist' },
	{ icon: '👩‍🎨', text: 'people body - woman artist' },
	{ icon: '👨‍✈️', text: 'people body - man pilot טייס' },
	{ icon: '👩‍✈️', text: 'people body - woman pilot טייסת' },
	{ icon: '👨‍🚀', text: 'people body - man astronaut' },
	{ icon: '👩‍🚀', text: 'people body - woman astronaut' },
	{ icon: '👨‍🚒', text: 'people body - man firefighter' },
	{ icon: '👩‍🚒', text: 'people body - woman firefighter' },
	{ icon: '👮', text: 'people body - police officer' },
	{ icon: '👮‍♂️', text: 'people body - man police officer' },
	{ icon: '👮‍♀️', text: 'people body - woman police officer' },
	{ icon: '🕵', text: 'people body - detective' },
	{ icon: '🕵️‍♂️', text: 'people body - man detective' },
	{ icon: '🕵️‍♀️', text: 'people body - woman detective' },
	{ icon: '💂', text: 'people body - guard' },
	{ icon: '💂‍♂️', text: 'people body - man guard' },
	{ icon: '💂‍♀️', text: 'people body - woman guard' },
	{ icon: '👷', text: 'people body - construction worker' },
	{ icon: '👷‍♂️', text: 'people body - man construction worker' },
	{ icon: '👷‍♀️', text: 'people body - woman construction worker' },
	{ icon: '🤴', text: 'people body - prince' },
	{ icon: '👸', text: 'people body - princess' },
	{ icon: '👳', text: 'people body - person wearing turban' },
	{ icon: '👳‍♂️', text: 'people body - man wearing turban' },
	{ icon: '👳‍♀️', text: 'people body - woman wearing turban' },
	{ icon: '👲', text: 'people body - man with Chinese cap' },
	{ icon: '', text: 'people body - ' },
	{ icon: '🧕', text: 'people body - woman with headscarf' },
	{ icon: '🤵', text: 'people body - man in tuxedo' },
	{ icon: '👰', text: 'people body - bride with veil' },
	{ icon: '🤰', text: 'people body - pregnant woman' },
	{ icon: '🤱', text: 'people body - breast-feeding' },
	{ icon: '👼', text: 'people body - baby angel' },
	{ icon: '🎅', text: 'people body - Santa Claus' },
	{ icon: '🤶', text: 'people body - Mrs. Claus' },
	{ icon: '🦸', text: 'people body - superhero' },
	{ icon: '🦸‍♂️', text: 'people body - man superhero' },
	{ icon: '🦸‍♀️', text: 'people body - woman superhero' },
	{ icon: '🦹', text: 'people body - supervillain' },
	{ icon: '🦹‍♂️', text: 'people body - man supervillain' },
	{ icon: '🦹‍♀️', text: 'people body - woman supervillain' },
	{ icon: '🧙', text: 'people body - mage' },
	{ icon: '🧙‍♂️', text: 'people body - man mage' },
	{ icon: '🧙‍♀️', text: 'people body - woman mage' },
	{ icon: '🧚', text: 'people body - fairy' },
	{ icon: '🧚‍♂️', text: 'people body - man fairy' },
	{ icon: '🧚‍♀️', text: 'people body - woman fairy' },
	{ icon: '🧛', text: 'people body - vampire' },
	{ icon: '🧛‍♂️', text: 'people body - man vampire' },
	{ icon: '🧛‍♀️', text: 'people body - woman vampire' },
	{ icon: '🧜', text: 'people body - merperson' },
	{ icon: '🧜‍♂️', text: 'people body - merman' },
	{ icon: '🧜‍♀️', text: 'people body - mermaid' },
	{ icon: '🧌', text: 'troll' },
	{ icon: '🧝', text: 'people body - elf' },
	{ icon: '🧝‍♂️', text: 'people body - man elf' },
	{ icon: '🧝‍♀️', text: 'people body - woman elf' },
	{ icon: '🧞', text: 'people body - genie gini jinni aladdin' },
	{ icon: '🧞‍♂️', text: 'people body - man genie gini jinni aladdin general' },
	{ icon: '🧞‍♀️', text: 'people body - woman genie gini jinni aladdin' },
	{ icon: '🧟', text: 'people body - zombie' },
	{ icon: '🧟‍♂️', text: 'people body - man zombie' },
	{ icon: '🧟‍♀️', text: 'people body - woman zombie' },
	{ icon: '💆', text: 'people body - person getting massage' },
	{ icon: '💆‍♂️', text: 'people body - man getting massage' },
	{ icon: '💆‍♀️', text: 'people body - woman getting massage' },
	{ icon: '💇', text: 'people body - person getting haircut' },
	{ icon: '💇‍♂️', text: 'people body - man getting haircut' },
	{ icon: '💇‍♀️', text: 'people body - woman getting haircut' },
	{ icon: '🚶', text: 'people body - person walking' },
	{ icon: '🚶‍♂️', text: 'people body - man walking' },
	{ icon: '🚶‍♀️', text: 'people body - woman walking' },
	{ icon: '🧍', text: 'people body - person standing' },
	{ icon: '🧍‍♂️', text: 'people body - man standing' },
	{ icon: '🧍‍♀️', text: 'people body - woman standing' },
	{ icon: '🧎', text: 'people body - person kneeling' },
	{ icon: '🧎‍♂️', text: 'people body - man kneeling' },
	{ icon: '🧎‍♀️', text: 'people body - woman kneeling' },
	{ icon: '👨‍🦯', text: 'people body - man with probing cane' },
	{ icon: '👩‍🦯', text: 'people body - woman with probing cane' },
	{ icon: '👨‍🦼', text: 'people body - man in motorized wheelchair' },
	{ icon: '👩‍🦼', text: 'people body - woman in motorized wheelchair' },
	{ icon: '👨‍🦽', text: 'people body - man in manual wheelchair' },
	{ icon: '👩‍🦽', text: 'people body - woman in manual wheelchair' },
	{ icon: '🏃', text: 'people body - person running' },
	{ icon: '🏃‍♂️', text: 'people body - man running' },
	{ icon: '🏃‍♀️', text: 'people body - woman running' },
	{ icon: '💃', text: 'people body - woman dancing party' },
	{ icon: '🕺', text: 'people body - man dancing party' },
	{ icon: '🕴', text: 'people body - man in suit levitating' },
	{ icon: '👯', text: 'people body - people with bunny ears' },
	{ icon: '👯‍♂️', text: 'people body - men with bunny ears' },
	{ icon: '👯‍♀️', text: 'people body - women with bunny ears' },
	{ icon: '🧖', text: 'people body - person in steamy room' },
	{ icon: '🧖‍♂️', text: 'people body - man in steamy room' },
	{ icon: '🧖‍♀️', text: 'people body - woman in steamy room' },
	{ icon: '🧗', text: 'people body - person climbing' },
	{ icon: '🧗‍♂️', text: 'people body - man climbing' },
	{ icon: '🧗‍♀️', text: 'people body - woman climbing' },
	{ icon: '🤺', text: 'people body - person fencing' },
	{ icon: '🏇', text: 'people body - horse racing' },
	{ icon: '⛷', text: 'people body - skier' },
	{ icon: '🏂', text: 'people body - snowboarder' },
	{ icon: '🏌', text: 'people body - person golfing' },
	{ icon: '🏌️‍♂️', text: 'people body - man golfing' },
	{ icon: '🏌️‍♀️', text: 'people body - woman golfing' },
	{ icon: '🏄', text: 'people body - person surfing' },
	{ icon: '🏄‍♂️', text: 'people body - man surfing' },
	{ icon: '🏄‍♀️', text: 'people body - woman surfing' },
	{ icon: '🚣', text: 'people body - person rowing boat שיט אגם נהר אגמים נהרות סירה סירות הפלגה הפלגות' },
	{ icon: '🚣‍♂️', text: 'people body - man rowing boat שיט אגם נהר אגמים נהרות סירה סירות הפלגה הפלגות' },
	{ icon: '🚣‍♀️', text: 'people body - woman rowing boat שיט אגם נהר אגמים נהרות סירה סירות הפלגה הפלגות' },
	{ icon: '🏊', text: 'people body - person swimming' },
	{ icon: '🏊‍♂️', text: 'people body - man swimming' },
	{ icon: '🏊‍♀️', text: 'people body - woman swimming' },
	{ icon: '⛹', text: 'people body - person bouncing ball' },
	{ icon: '⛹️‍♂️', text: 'people body - man bouncing ball' },
	{ icon: '⛹️‍♀️', text: 'people body - woman bouncing ball' },
	{ icon: '🏋', text: 'people body - person lifting weights' },
	{ icon: '🏋️‍♂️', text: 'people body - man lifting weights' },
	{ icon: '🏋️‍♀️', text: 'people body - woman lifting weights' },
	{ icon: '🚴', text: 'people body - person biking' },
	{ icon: '🚴‍♂️', text: 'people body - man biking' },
	{ icon: '🚴‍♀️', text: 'people body - woman biking' },
	{ icon: '🚵', text: 'people body - person mountain הר הרים biking' },
	{ icon: '🚵‍♂️', text: 'people body - man mountain הר הרים biking' },
	{ icon: '🚵‍♀️', text: 'people body - woman mountain הר הרים biking' },
	{ icon: '🤸', text: 'people body - person cartwheeling' },
	{ icon: '🤸‍♂️', text: 'people body - man cartwheeling' },
	{ icon: '🤸‍♀️', text: 'people body - woman cartwheeling' },
	{ icon: '🤼', text: 'people body - people wrestling' },
	{ icon: '🤼‍♂️', text: 'people body - men wrestling' },
	{ icon: '🤼‍♀️', text: 'people body - women wrestling' },
	{ icon: '🤽', text: 'people body - person playing water polo' },
	{ icon: '🤽‍♂️', text: 'people body - man playing water polo' },
	{ icon: '🤽‍♀️', text: 'people body - woman playing water polo' },
	{ icon: '🤾', text: 'people body - person playing handball' },
	{ icon: '🤾‍♂️', text: 'people body - man playing handball' },
	{ icon: '🤾‍♀️', text: 'people body - woman playing handball' },
	{ icon: '🤹', text: 'people body - person juggling' },
	{ icon: '🤹‍♂️', text: 'people body - man juggling' },
	{ icon: '🤹‍♀️', text: 'people body - woman juggling' },
	{ icon: '🧘', text: 'people body - person in lotus position' },
	{ icon: '🧘‍♂️', text: 'people body - man in lotus position' },
	{ icon: '🧘‍♀️', text: 'people body - woman in lotus position' },
	{ icon: '🛀', text: 'people body - person taking bath' },
	{ icon: '🛌', text: 'people body - person in bed' },
	{ icon: '🧑‍🤝‍🧑', text: 'people body - people holding hands' },
	{ icon: '👭', text: 'people body - women holding hands' },
	{ icon: '👫', text: 'people body - woman and man holding hands' },
	{ icon: '👬', text: 'people body - men holding hands' },
	{ icon: '💏', text: 'people body - kiss' },
	{ icon: '👩‍❤️‍💋‍👨', text: 'people body - kiss: woman, man' },
	{ icon: '👨‍❤️‍💋‍👨', text: 'people body - kiss: man, man' },
	{ icon: '👩‍❤️‍💋‍👩', text: 'people body - kiss: woman, woman' },
	{ icon: '💑', text: 'people body - couple with heart' },
	{ icon: '👩‍❤️‍👨', text: 'people body - couple with heart: woman, man' },
	{ icon: '👨‍❤️‍👨', text: 'people body - couple with heart: man, man' },
	{ icon: '👩‍❤️‍👩', text: 'people body - couple with heart: woman, woman' },
	{ icon: '👪', text: 'people body - family' },
	{ icon: '👨‍👩‍👦', text: 'people body - family: man, woman, boy' },
	{ icon: '👨‍👩‍👧', text: 'people body - family: man, woman, girl' },
	{ icon: '👨‍👩‍👧‍👦', text: 'people body - family: man, woman, girl, boy' },
	{ icon: '👨‍👩‍👦‍👦', text: 'people body - family: man, woman, boy, boy' },
	{ icon: '👨‍👩‍👧‍👧', text: 'people body - family: man, woman, girl, girl' },
	{ icon: '👨‍👨‍👦', text: 'people body - family: man, man, boy' },
	{ icon: '👨‍👨‍👧', text: 'people body - family: man, man, girl' },
	{ icon: '👨‍👨‍👧‍👦', text: 'people body - family: man, man, girl, boy' },
	{ icon: '👨‍👨‍👦‍👦', text: 'people body - family: man, man, boy, boy' },
	{ icon: '👨‍👨‍👧‍👧', text: 'people body - family: man, man, girl, girl' },
	{ icon: '👩‍👩‍👦', text: 'people body - family: woman, woman, boy' },
	{ icon: '👩‍👩‍👧', text: 'people body - family: woman, woman, girl' },
	{ icon: '👩‍👩‍👧‍👦', text: 'people body - family: woman, woman, girl, boy' },
	{ icon: '👩‍👩‍👦‍👦', text: 'people body - family: woman, woman, boy, boy' },
	{ icon: '👩‍👩‍👧‍👧', text: 'people body - family: woman, woman, girl, girl' },
	{ icon: '👨‍👦', text: 'people body - family: man, boy' },
	{ icon: '👨‍👦‍👦', text: 'people body - family: man, boy, boy' },
	{ icon: '👨‍👧', text: 'people body - family: man, girl' },
	{ icon: '👨‍👧‍👦', text: 'people body - family: man, girl, boy' },
	{ icon: '👨‍👧‍👧', text: 'people body - family: man, girl, girl' },
	{ icon: '👩‍👦', text: 'people body - family: woman, boy' },
	{ icon: '👩‍👦‍👦', text: 'people body - family: woman, boy, boy' },
	{ icon: '👩‍👧', text: 'people body - family: woman, girl' },
	{ icon: '👩‍👧‍👦', text: 'people body - family: woman, girl, boy' },
	{ icon: '👩‍👧‍👧', text: 'people body - family: woman, girl, girl' },
	{ icon: '🗣', text: 'people body - speaking head' },
	{ icon: '👤', text: 'people body - bust in silhouette' },
	{ icon: '👥', text: 'people body - busts in silhouette' },
	{ icon: '👣', text: 'people body - footprints' },
	{ icon: '🐵', text: 'animals nature - monkey face' },
	{ icon: '🐒', text: 'animals nature - monkey' },
	{ icon: '🦍', text: 'animals nature - gorilla' },
	{ icon: '🦧', text: 'animals nature - orangutan' },
	{ icon: '🐶', text: 'animals nature - dog face' },
	{ icon: '🐕', text: 'animals nature - dog' },
	{ icon: '🦮', text: 'animals nature - guide dog' },
	{ icon: '🐕‍🦺', text: 'animals nature - service dog' },
	{ icon: '🐩', text: 'animals nature - poodle' },
	{ icon: '🐺', text: 'animals nature - wolf' },
	{ icon: '🦊', text: 'animals nature - fox' },
	{ icon: '🦝', text: 'animals nature - raccoon' },
	{ icon: '🐱', text: 'animals nature - cat face' },
	{ icon: '🐈', text: 'animals nature - cat' },
	{ icon: '🦁', text: 'animals nature - lion' },
	{ icon: '🐯', text: 'animals nature - tiger face' },
	{ icon: '🐅', text: 'animals nature - tiger' },
	{ icon: '🐆', text: 'animals nature - leopard גן חיות zoo' },
	{ icon: '🐴', text: 'animals nature - horse face' },
	{ icon: '🐎', text: 'animals nature - horse' },
	{ icon: '🦄', text: 'animals nature - unicorn חד קרן gimmicks גימיקים' },
	{ icon: '🦓', text: 'animals nature - zebra' },
	{ icon: '🦌', text: 'animals nature - deer' },
	{ icon: '🐮', text: 'animals nature - cow face פרה פרות' },
	{ icon: '🐂', text: 'animals nature - ox' },
	{ icon: '🐃', text: 'animals nature - water buffalo פרה בופאלו' },
	{ icon: '🐄', text: 'animals nature - cow פרה פרות' },
	{ icon: '🐷', text: 'animals nature - pig face' },
	{ icon: '🐖', text: 'animals nature - pig' },
	{ icon: '🐗', text: 'animals nature - boar' },
	{ icon: '🐽', text: 'animals nature - pig nose' },
	{ icon: '🐏', text: 'animals nature - ram' },
	{ icon: '🐑', text: 'animals nature - ewe' },
	{ icon: '🐐', text: 'animals nature - goat' },
	{ icon: '🐪', text: 'animals nature - camel' },
	{ icon: '🐫', text: 'animals nature - two-hump camel' },
	{ icon: '🦙', text: 'animals nature - llama' },
	{ icon: '🦒', text: 'animals nature - giraffe' },
	{ icon: '🐘', text: 'animals nature - elephant' },
	{ icon: '🦏', text: 'animals nature - rhinoceros' },
	{ icon: '🦛', text: 'animals nature - hippopotamus' },
	{ icon: '🐭', text: 'animals nature - mouse face' },
	{ icon: '🐁', text: 'animals nature - mouse' },
	{ icon: '🐀', text: 'animals nature - rat' },
	{ icon: '🐹', text: 'animals nature - hamster' },
	{ icon: '🐰', text: 'animals nature - rabbit face' },
	{ icon: '🐇', text: 'animals nature - rabbit' },
	{ icon: '🐿', text: 'animals nature - chipmunk' },
	{ icon: '🦔', text: 'animals nature - hedgehog' },
	{ icon: '🦇', text: 'animals nature - bat' },
	// { icon: '', text: "animals nature - "},
	{ icon: '🐻', text: 'animals nature - bear' },
	{ icon: '🐨', text: 'animals nature - koala' },
	{ icon: '🐼', text: 'animals nature - panda' },
	{ icon: '🦥', text: 'animals nature - sloth' },
	{ icon: '🦦', text: 'animals nature - otter' },
	{ icon: '🦨', text: 'animals nature - skunk' },
	{ icon: '🦘', text: 'animals nature - kangaroo' },
	{ icon: '🦡', text: 'animals nature - badger' },
	{ icon: '🐾', text: 'animals nature - paw prints' },
	{ icon: '🦃', text: 'animals nature - turkey בשר תרנגול' },
	{ icon: '🐔', text: 'animals nature - chicken בשר תרנגול' },
	{ icon: '🐓', text: 'animals nature - rooster' },
	{ icon: '🐣', text: 'animals nature - hatching chick' },
	{ icon: '🐤', text: 'animals nature - baby chick' },
	{ icon: '🐥', text: 'animals nature - front-facing baby chick' },
	{ icon: '🐦', text: 'animals nature - bird' },
	{ icon: '🐧', text: 'animals nature - penguin' },
	{ icon: '🕊', text: 'animals nature - dove' },
	{ icon: '🦅', text: 'animals nature - eagle' },
	{ icon: '🦆', text: 'animals nature - duck' },
	{ icon: '🦢', text: 'animals nature - swan' },
	{ icon: '🦉', text: 'animals nature - owl' },
	{ icon: '🦩', text: 'animals nature - flamingo' },
	{ icon: '🦚', text: 'animals nature - peacock ירוק' },
	{ icon: '🦜', text: 'animals nature - parrot ירוק' },
	{ icon: '🐸', text: 'animals nature - frog ירוק צפרדע' },
	{ icon: '🐊', text: 'animals nature - crocodile ירוק תנין קרוקודיל' },
	{ icon: '🐢', text: 'animals nature - turtle ירוק צב' },
	{ icon: '🦎', text: 'animals nature - lizard ירוק לטאה' },
	{ icon: '🐍', text: 'animals nature - snake נחש ירוק' },
	{ icon: '🐲', text: 'animals nature - dragon face דרקון ירוק' },
	{ icon: '🐉', text: 'animals nature - dragon דרקון ירוק' },
	{ icon: '🦕', text: 'animals nature - sauropod דינוזאור כחול' },
	{ icon: '🦖', text: 'animals nature - T-Rex דינוזאור ירוק דרקון' },
	{ icon: '🐳', text: 'animals nature - spouting whale' },
	{ icon: '🐋', text: 'animals nature - whale' },
	{ icon: '🐬', text: 'animals nature - dolphin' },
	{ icon: '🐟', text: 'animals nature - fish' },
	{ icon: '🐠', text: 'animals nature - tropical fish' },
	{ icon: '🐡', text: 'animals nature - blowfish' },
	{ icon: '🦈', text: 'animals nature - shark טבע כריש ים' },
	{ icon: '🐙', text: 'animals nature - octopus טבע תמנון' },
	{ icon: '🐚', text: 'animals nature - spiral shell טבע ים חופים כונכייה' },
	{ icon: '🐌', text: 'animals nature - snail טבע חילזון' },
	{ icon: '🦋', text: 'animals nature - butterfly nature טבע עיירות נופים פרפר כחול' },
	{ icon: '🐛', text: 'animals nature - bug טבע נופים' },
	{ icon: '🐜', text: 'animals nature - ant' },
	{ icon: '🐝', text: 'animals nature - honeybee טבע דבורה דבורים' },
	{ icon: '🐞', text: 'animals nature - lady beetle חיפושית' },
	{ icon: '🦗', text: 'animals nature - cricket' },
	{ icon: '🕷', text: 'animals nature - spider  טבע עכביש שחור' },
	{ icon: '🕸', text: 'animals nature - spider web טבע עכביש שחור' },
	{ icon: '🦂', text: 'animals nature - scorpion' },
	{ icon: '🦟', text: 'animals nature - mosquito' },
	{ icon: '🦠', text: 'animals nature - microbe' },
	{ icon: '💐', text: 'animals nature - bouquet' },
	{ icon: '🌸', text: 'טבע פרח flower animals nature - cherry blossom' },
	{ icon: '💮', text: 'טבע פרח flower animals nature - white flower' },
	{ icon: '🏵', text: 'טבע פרח flower animals nature - rosette' },
	{ icon: '🌹', text: 'טבע פרח flower animals nature - rose' },
	{ icon: '🥀', text: 'טבע פרח flower animals nature - wilted flower' },
	{ icon: '🌺', text: 'טבע פרח flower animals nature - hibiscus' },
	{ icon: '🌻', text: 'טבע פרח flower animals nature - sunflower' },
	{ icon: '🌼', text: 'טבע פרח flower animals nature - blossom' },
	{ icon: '🌷', text: 'טבע פרח flower טבע פרח animals nature - tulip' },
	{ icon: '🌱', text: 'green ירוק טבע animals nature - seedling' },
	{ icon: '🌲', text: 'green ירוק טבע animals nature - evergreen tree' },
	{ icon: '🌳', text: 'green ירוק טבע animals nature - deciduous tree' },
	{ icon: '🌴', text: 'green ירוק טבע animals nature - palm tree' },
	{ icon: '🌵', text: 'green ירוק טבע animals nature - cactus' },
	{ icon: '🌾', text: 'green ירוק טבע animals nature - sheaf of rice' },
	{ icon: '🌿', text: 'green ירוק טבע animals nature - herb' },
	{ icon: '☘', text: 'green ירוק טבע animals nature - shamrock general' },
	{ icon: '🍀', text: 'green ירוק טבע animals nature - four leaf clover' },
	{ icon: '🍁', text: 'animals nature - maple leaf' },
	{ icon: '🍂', text: 'animals nature - fallen leaf' },
	{ icon: '🍃', text: 'animals nature - leaf fluttering in wind' },
	{ icon: '🍇', text: 'אוכל food - grapes' },
	{ icon: '🍈', text: 'אוכל food - melon' },
	{ icon: '🍉', text: 'אוכל food - watermelon' },
	{ icon: '🍊', text: 'אוכל food - tangerine' },
	{ icon: '🍋', text: 'אוכל food - lemon' },
	{ icon: '🍌', text: 'אוכל food - banana' },
	{ icon: '🍍', text: 'אוכל food - pineapple' },
	{ icon: '🥭', text: 'אוכל food - mango' },
	{ icon: '🍎', text: 'אוכל food - red apple' },
	{ icon: '🍏', text: 'אוכל food - green apple' },
	{ icon: '🍐', text: 'אוכל food - pear' },
	{ icon: '🍑', text: 'אוכל food - peach' },
	{ icon: '🍒', text: 'אוכל food - cherries' },
	{ icon: '🍓', text: 'אוכל food - strawberry' },
	{ icon: '🥝', text: 'אוכל food - kiwi fruit' },
	{ icon: '🍅', text: 'אוכל food - tomato' },
	{ icon: '🥥', text: 'אוכל food - coconut' },
	{ icon: '🥑', text: 'אוכל food - avocado' },
	{ icon: '🍆', text: 'אוכל food - eggplant' },
	{ icon: '🥔', text: 'אוכל food - potato' },
	{ icon: '🥕', text: 'אוכל food - carrot' },
	{ icon: '🌽', text: 'אוכל food - ear of corn' },
	{ icon: '🌶', text: 'אוכל food - hot pepper' },
	{ icon: '🥒', text: 'אוכל food - cucumber' },
	{ icon: '🥬', text: 'אוכל food - leafy green' },
	{ icon: '🥦', text: 'אוכל food - broccoli' },
	{ icon: '🧄', text: 'אוכל food - garlic' },
	{ icon: '🧅', text: 'אוכל food - onion' },
	{ icon: '🍄', text: 'אוכל food - mushroom' },
	{ icon: '🥜', text: 'אוכל food - peanuts' },
	{ icon: '🌰', text: 'אוכל food - chestnut' },
	{ icon: '🍞', text: 'אוכל food - bread' },
	{ icon: '🥐', text: 'אוכל food - croissant' },
	{ icon: '🥖', text: 'אוכל food - baguette bread' },
	{ icon: '🥨', text: 'אוכל בייגלה פרעצל food - pretzel' },
	{ icon: '🥯', text: 'אוכל food - bagel' },
	{ icon: '🥞', text: 'אוכל food - pancakes' },
	{ icon: '🧇', text: 'אוכל food - waffle' },
	{ icon: '🧀', text: 'אוכל food - cheese wedge' },
	{ icon: '🍖', text: 'בשר steak סטייק סטייקים מסעדת בשר אוכל food - meat on bone' },
	{ icon: '🍗', text: 'אוכל בשר steak סטייק סטייקים מסעדת בשר food - poultry leg' },
	{ icon: '🥩', text: 'אוכל בשר steak סטייק סטייקים מסעדת בשר food - cut of meat' },
	{ icon: '🥓', text: 'אוכל בשר steak סטייק סטייקים מסעדת בשר food - bacon' },
	{ icon: '🍔', text: 'אוכל בשר food - hamburger המבורגר' },
	{ icon: '🍟', text: 'אוכל food - french fries' },
	{ icon: '🍕', text: 'אוכל food - pizza פיצה' },
	{ icon: '🌭', text: 'אוכל נקניקיות נקניקייה נקניקיה food - hot dog' },
	{ icon: '🥪', text: 'אוכל food - sandwich' },
	{ icon: '🌮', text: 'אוכל טאקוס נאצ׳וס נאצוס מקסיקו food - taco' },
	{ icon: '🌯', text: 'אוכל בוריטו טורטייה מקסיקו food - burrito' },
	{ icon: '🥙', text: 'אוכל food - stuffed flatbread' },
	{ icon: '🧆', text: 'אוכל פלאפל food - falafel' },
	{ icon: '🥚', text: 'אוכל ביצה food - egg' },
	{ icon: '🍳', text: 'אוכל food - cooking' },
	{ icon: '🥘', text: 'אוכל food - shallow pan of food' },
	{ icon: '🍲', text: 'אוכל food - pot of food' },
	{ icon: '🥣', text: 'אוכל food - bowl with spoon' },
	{ icon: '🥗', text: 'אוכל food - green salad' },
	{ icon: '🍿', text: 'אוכל סרט פופקורן cinema movie movies food - popcorn' },
	{ icon: '🧈', text: 'אוכל food - butter' },
	{ icon: '🧂', text: 'אוכל food - salt' },
	{ icon: '🥫', text: 'אוכל food - canned food' },
	{ icon: '🍱', text: 'אוכל food - bento box' },
	{ icon: '🍘', text: 'אוכל food - rice cracker' },
	{ icon: '🍙', text: 'אוכל food - rice ball' },
	{ icon: '🍚', text: 'אוכל food - cooked rice' },
	{ icon: '🍛', text: 'אוכל food - curry rice' },
	{ icon: '🍜', text: 'אוכל food - steaming bowl' },
	{ icon: '🍝', text: 'אוכל food - spaghetti' },
	{ icon: '🍠', text: 'אוכל food - roasted sweet potato' },
	{ icon: '🍢', text: 'אוכל food - oden' },
	{ icon: '🍣', text: 'אוכל food - sushi' },
	{ icon: '🍤', text: 'אוכל food - fried shrimp' },
	{ icon: '🍥', text: 'אוכל food - fish cake with swirl' },
	{ icon: '🥮', text: 'אוכל food - moon cake' },
	{ icon: '🍡', text: 'אוכל food - dango' },
	{ icon: '🥟', text: 'אוכל food - dumpling' },
	{ icon: '🥠', text: 'אוכל food - fortune cookie' },
	{ icon: '🥡', text: 'אוכל food - takeout box' },
	{ icon: '🦀', text: 'אוכל food - crab' },
	{ icon: '🦞', text: 'אוכל food - lobster' },
	{ icon: '🦐', text: 'אוכל food - shrimp' },
	{ icon: '🦑', text: 'אוכל food - squid' },
	{ icon: '🦪', text: 'אוכל food - oyster' },
	{ icon: '🍦', text: 'אוכל food - soft ice cream קינוחים ממתקים גלידה קינוח ממתק' },
	{ icon: '🍧', text: 'אוכל food - shaved ice קינוחים ממתקים גלידה קינוח ממתק' },
	{ icon: '🍨', text: 'אוכל food - ice cream קינוחים ממתקים קינוח ממתק' },
	{ icon: '🍩', text: 'אוכל food - doughnut קינוחים ממתקים donut דונאט סופגנייה קינוח ממתק' },
	{ icon: '🍪', text: 'אוכל food - cookie קינוחים ממתקים עוגייה עוגיה עוגיות קינוח ממתק' },
	{ icon: '🎂', text: 'אוכל food - birthday cake קינוחים ממתקים עוגה cake קינוח ממתק' },
	{ icon: '🍰', text: 'אוכל food - shortcake קינוחים ממתקים עוגה cake קינוח ממתק' },
	{ icon: '🧁', text: 'אוכל food - cupcake קינוחים ממתקים קינוח ממתק' },
	{ icon: '🥧', text: 'אוכל food - pie קינוחים ממתקים קינוח ממתק' },
	{ icon: '🍫', text: 'אוכל food - chocolate bar קינוחים ממתקים שוקולד שוקולדים קינוח ממתק' },
	{ icon: '🍬', text: 'אוכל food - candy קינוחים ממתקים קינוח ממתק' },
	{ icon: '🍭', text: 'אוכל food - lollipop קינוחים ממתקים קינוח ממתק' },
	{ icon: '🍮', text: 'אוכל food - custard' },
	{ icon: '🍯', text: 'אוכל food - honey pot' },
	{ icon: '🍼', text: 'אוכל food - baby bottle' },
	{ icon: '🥛', text: 'אוכל חלב food - glass of milk' },
	{ icon: '☕', text: 'אוכל קפה בית קפה בתי קפה coffee cafe food - hot beverage' },
	{ icon: '🍵', text: 'אוכל food - teacup without handle' },
	{ icon: '🍶', text: 'אוכל food - sake' },
	{
		icon: '🍾',
		text: 'אוכל food - drink דרינק שתייה bottle with popping cork bar club nightlife ברים וחיי לילה אלכוהול alcohol בירה בירות bar night life',
	},
	{
		icon: '🍷',
		text: 'אוכל fooddrink דרינק שתייה  - יין יקב יקבים wine glass bar club nightlifeברים וחיי לילה אלכוהול alcohol בירה בירות bar night life',
	},
	{
		icon: '🍸',
		text: 'אוכל food - drink דרינק שתייה cocktail glass bar club nightlifeברים וחיי לילה אלכוהול alcohol בירה בירות bar night life',
	},
	{
		icon: '🍹',
		text: 'אוכל food - drink דרינק שתייה tropical drink bar club nightlifeברים וחיי לילה אלכוהול alcohol בירה בירות bar night life',
	},
	{
		icon: '🍺',
		text: 'אוכל food - drink דרינק שתייה beer mug bar club nightlifeברים וחיי לילה אלכוהול alcohol בירה בירות bar night life',
	},
	{
		icon: '🍻',
		text: 'אוכל food - drink דרינק שתייה clinking beer mugs bar club nightlifeברים וחיי לילה אלכוהול alcohol בירה בירות bar night life',
	},
	{
		icon: '🥂',
		text: 'אוכל food - drink דרינק שתייה clinking glasses bar club nightlifeברים וחיי לילה אלכוהול alcohol בירה בירות bar night life',
	},
	{
		icon: '🥃',
		text: 'אוכל food - drink דרינק שתייה tumbler glass bar club nightlifeברים וחיי לילה אלכוהול alcohol בירה בירות bar night life',
	},
	{ icon: '🥤', text: 'אוכל food - drink דרינק שתייה cup with straw bar club nightlife' },
	{ icon: '🧃', text: 'אוכל food - drink דרינק שתייה beverage box' },
	{ icon: '🧉', text: 'אוכל food - drink דרינק שתייה mate' },
	{ icon: '🧊', text: 'אוכל food - ice' },
	{ icon: '🥢', text: 'אוכל food - chopsticks' },
	{ icon: '🍽', text: 'אוכל food - fork and knife with plate' },
	{ icon: '🍴', text: 'אוכל food - fork and knife' },
	{ icon: '🥄', text: 'אוכל food - spoon' },
	{ icon: '🔪', text: 'halloween אוכל סכין food - kitchen knife' },
	{ icon: '🏺', text: 'אוכל food - amphora' },
	{ icon: '🎃', text: 'activities activity - jack-o-lantern חג חגים האלווין halloween' },
	{ icon: '🎄', text: 'activities activity - Christmas tree' },
	{ icon: '🎆', text: 'activities activity - fireworks זיקוק אש' },
	{ icon: '🎇', text: 'activities activity - sparkler זיקוק אש' },
	{ icon: '🧨', text: 'activities activity - firecracker חובה אש' },
	{ icon: '✨', text: 'activities activity - sparkles כוכב מוזהב star' },
	{ icon: '🎈', text: 'activities activity - balloon בלון יום הולדת' },
	{ icon: '🎉', text: 'activities activity - party popper מסיבה יום הולדת parties celebrations חגיגה' },
	{ icon: '🎊', text: 'activities activity - confetti ball מסיבה יום הולדת parties celebrations חגיגה' },
	{ icon: '🎋', text: 'activities activity - tanabata tree' },
	{ icon: '🎍', text: 'activities activity - pine decoration' },
	{ icon: '🎎', text: 'activities activity - Japanese dolls' },
	{ icon: '🎏', text: 'activities activity - carp streamer' },
	{ icon: '🎐', text: 'activities activity - wind chime' },
	{ icon: '🎑', text: 'activities activity - moon viewing ceremony' },
	{ icon: '🧧', text: 'activities activity - red envelope' },
	{ icon: '🎀', text: 'activities activity - ribbon הפתעות מתנות יום הולדת gift gifts' },
	{ icon: '🎁', text: 'activities activity - wrapped gift מסיבה יום הולדת presents מתנות הפתעות' },
	{ icon: '🎗', text: 'activities activity - reminder ribbon' },
	{ icon: '🎟', text: 'activities activity - admission tickets' },
	{ icon: '🎫', text: 'activities activity - ticket' },
	{ icon: '🎖', text: 'activities activity - military medal ספורט' },
	{ icon: '🏆', text: 'activities activity - trophy champ champion ספורט' },
	{ icon: '🏅', text: 'activities activity - sports medal ספורט' },
	{ icon: '🥇', text: 'activities activity - 1st place medal ספורט' },
	{ icon: '🥈', text: 'activities activity - 2nd place medal ספורט' },
	{ icon: '🥉', text: 'activities activity - 3rd place medal ספורט' },
	{ icon: '⚽', text: 'activities activity - soccer ball ספורט' },
	{ icon: '⚾', text: 'activities activity - baseball ספורט' },
	{ icon: '🥎', text: 'activities activity - softball ספורט' },
	{ icon: '🏀', text: 'activities activity - basketball ספורט' },
	{ icon: '🏐', text: 'activities activity - volleyball ספורט' },
	{ icon: '🏈', text: 'activities activity - american football ספורט' },
	{ icon: '🏉', text: 'activities activity - rugby football ספורט' },
	{ icon: '🎾', text: 'activities activity - tennis ספורט' },
	{ icon: '🥏', text: 'activities activity - flying disc ספורט' },
	{ icon: '🎳', text: 'activities activity - bowling ספורט' },
	{ icon: '🏏', text: 'activities activity - cricket game ספורט' },
	{ icon: '🏑', text: 'activities activity - field hockey ספורט' },
	{ icon: '🏒', text: 'activities activity - ice hockey ספורט' },
	{ icon: '🥍', text: 'activities activity - lacrosse ספורט' },
	{ icon: '🏓', text: 'activities activity - ping pong ספורט' },
	{ icon: '🏸', text: 'activities activity - badminton ספורט' },
	{ icon: '🥊', text: 'activities activity - boxing glove ספורט' },
	{ icon: '🥋', text: 'activities activity - martial arts uniform ספורט' },
	{ icon: '🥅', text: 'activities activity - goal net ספורט' },
	{ icon: '⛳', text: 'activities activity - flag in hole' },
	{ icon: '⛸', text: 'activities activity - ice skate' },
	{ icon: '🎣', text: 'activities activity - fishing pole' },
	{ icon: '🤿', text: 'activities activity - diving mask' },
	{ icon: '🎽', text: 'activities activity - running shirt' },
	{ icon: '🎿', text: 'activities activity - skis' },
	{ icon: '🛷', text: 'activities activity - sled' },
	{ icon: '🥌', text: 'activities activity - curling stone' },
	{ icon: '🎯', text: 'activities activity - direct hit attraction אטרקציות' },
	{ icon: '🪀', text: 'activities activity - yo-yo' },
	{ icon: '🪁', text: 'activities activity - kite' },
	{ icon: '🎱', text: 'activities activity - pool 8 ball' },
	{ icon: '🔮', text: 'activities activity - crystal ball' },
	{ icon: '🧿', text: 'activities activity - nazar amulet' },
	{ icon: '🎮', text: 'activities activity - video game' },
	{ icon: '🕹', text: 'activities activity - joystick' },
	{ icon: '🎰', text: 'activities activity - slot machine' },
	{ icon: '🎲', text: 'activities activity - game die games gumble' },
	{ icon: '🧩', text: 'activities activity - puzzle piece' },
	{ icon: '🧸', text: 'activities activity - teddy bear' },
	{ icon: '🃏', text: 'activities activity - joker card cards' },
	{ icon: '🀄', text: 'activities activity - mahjong red dragon card' },
	{ icon: '🎴', text: 'activities activity - flower playing cards' },
	{ icon: '🎭', text: 'activities activity - performing arts' },
	{ icon: '🖼', text: 'activities activity - framed picture' },
	{ icon: '🎨', text: 'activities activity - artist palette ציור אומנות art' },
	{ icon: '🧵', text: 'activities activity - thread' },
	{ icon: '🧶', text: 'activities activity - yarn' },
	{ icon: '👓', text: 'objects - glasses משקפיים משקפי שמש' },
	{ icon: '🕶', text: 'objects - sunglasses משקפיים משקפי שמש' },
	{ icon: '🥽', text: 'objects - goggles' },
	{ icon: '🥼', text: 'objects - lab coat' },
	{ icon: '🦺', text: 'objects - safety vest' },
	{ icon: '👔', text: 'objects - necktie בגדים' },
	{ icon: '👕', text: 'objects - t-shirt בגדים' },
	{ icon: '👖', text: 'objects - jeans בגדים' },
	{ icon: '🧣', text: 'objects - scarf' },
	{ icon: '🧤', text: 'objects - gloves' },
	{ icon: '🧥', text: 'objects - coat' },
	{ icon: '🧦', text: 'objects - socks' },
	{ icon: '👗', text: 'objects - dress שמלה הופעות' },
	{ icon: '👘', text: 'objects - kimono' },
	{ icon: '🥻', text: 'objects - sari' },
	{ icon: '🩱', text: 'objects - one-piece swimsuit בריכה בגד ים' },
	{ icon: '🩲', text: 'objects - briefs בגד ים בגדי ים' },
	{ icon: '🩳', text: 'objects - shorts בגד ים בגדי ים' },
	{ icon: '👙', text: 'objects - bikini ביקיני בריכה בגד ים בגדי ים' },
	{ icon: '👚', text: 'objects - woman’s clothes' },
	{ icon: '👛', text: 'objects - purse' },
	{ icon: '👜', text: 'objects - handbag' },
	{ icon: '💼', text: 'bag case travel suitcase' },
	{ icon: '🧳', text: 'bag case travel suitcase 2' },
	{ icon: '👝', text: 'objects - clutch bag' },
	{ icon: '🛍', text: 'objects - shopping bags קניות stores malls' },
	{ icon: '🎒', text: 'objects - backpack' },
	{ icon: '👞', text: 'objects - man’s shoe' },
	{ icon: '👟', text: 'objects - running shoe' },
	{ icon: '🥾', text: 'objects - hiking boot' },
	{ icon: '🥿', text: 'objects - flat shoe' },
	{ icon: '👠', text: 'objects - high-heeled shoe אלגנט ערב' },
	{ icon: '👡', text: 'objects - woman’s sandal' },
	{ icon: '🩰', text: 'objects - ballet shoes' },
	{ icon: '👢', text: 'objects - woman’s boot' },
	{ icon: '👑', text: 'objects - crown royal מלכותי מלכה מלך' },
	{ icon: '👒', text: 'objects - woman’s hat' },
	{ icon: '🎩', text: 'objects - top hat' },
	{ icon: '🎓', text: 'objects - graduation cap' },
	{ icon: '🧢', text: 'objects - billed cap' },
	{ icon: '⛑', text: 'objects - rescue worker’s helmet' },
	{ icon: '📿', text: 'objects - prayer beads' },
	{ icon: '💄', text: 'objects - lipstick' },
	{ icon: '💍', text: 'objects - ring' },
	{ icon: '💎', text: 'objects - gem stone' },
	{ icon: '🔇', text: 'objects - muted speaker' },
	{ icon: '🔈', text: 'objects - speaker low volume' },
	{ icon: '🔉', text: 'objects - speaker medium volume' },
	{ icon: '🔊', text: 'objects - speaker high volume' },
	{ icon: '📢', text: 'objects - loudspeaker' },
	{ icon: '📣', text: 'objects - megaphone' },
	{ icon: '📯', text: 'objects - postal horn' },
	{ icon: '🔔', text: 'objects - bell' },
	{ icon: '🔕', text: 'objects - bell with slash' },
	{ icon: '🎼', text: 'objects - musical score' },
	{ icon: '🎵', text: 'objects - musical note' },
	{ icon: '🎶', text: 'objects - musical notes' },
	{ icon: '🎙', text: 'objects - studio microphone' },
	{ icon: '🎚', text: 'objects - level slider' },
	{ icon: '🎛', text: 'objects - control knobs' },
	{ icon: '🎤', text: 'objects - microphone הופעות מוזיקה שירים' },
	{ icon: '🎧', text: 'objects - headphone מוזיקה שירים הופעות' },
	{ icon: '📻', text: 'objects - radio' },
	{ icon: '🎷', text: 'objects - saxophone' },
	{ icon: '🎸', text: 'objects - guitar' },
	{ icon: '🎹', text: 'objects - musical keyboard' },
	{ icon: '🎺', text: 'objects - trumpet' },
	{ icon: '🎻', text: 'objects - violin' },
	{ icon: '🪕', text: 'objects - banjo' },
	{ icon: '🥁', text: 'objects - drum' },
	{ icon: '📱', text: 'objects - mobile phone' },
	{ icon: '📲', text: 'objects - mobile phone with arrow' },
	{ icon: '☎', text: 'objects - telephone' },
	{ icon: '📞', text: 'objects - telephone receiver' },
	{ icon: '📟', text: 'objects - pager' },
	{ icon: '📠', text: 'objects - fax machine' },
	{ icon: '🔋', text: 'objects - battery' },
	{ icon: '🔌', text: 'objects - electric plug' },
	{ icon: '💻', text: 'objects - laptop pc computer' },
	{ icon: '🖥', text: 'objects - desktop computer screen' },
	{ icon: '🖨', text: 'objects - printer' },
	{ icon: '⌨', text: 'objects - keyboard' },
	{ icon: '🖱', text: 'objects - computer mouse' },
	{ icon: '🖲', text: 'objects - trackball' },
	{ icon: '💽', text: 'objects - computer disk' },
	{ icon: '💾', text: 'objects - floppy disk' },
	{ icon: '💿', text: 'objects - optical disk' },
	{ icon: '📀', text: 'objects - dvd' },
	{ icon: '🧮', text: 'objects - abacus' },
	{ icon: '🎥', text: 'objects - movie camera photo photos' },
	{ icon: '🎞', text: 'objects - film frames' },
	{ icon: '📽', text: 'objects - film projector photo photos' },
	{ icon: '🎬', text: 'objects - clapper board photo photos' },
	{ icon: '📺', text: 'objects - television tv photo photos' },
	{ icon: '📷', text: 'objects - camera photo photos' },
	{ icon: '📸', text: 'objects - camera with flash photo photos' },
	{ icon: '📹', text: 'objects - video camera photo photos' },
	{ icon: '📼', text: 'objects - videocassette' },
	{ icon: '🔍', text: 'objects - magnifying glass tilted left' },
	{ icon: '🔎', text: 'objects - magnifying glass tilted right' },
	{ icon: '🕯', text: 'objects - candle' },
	{ icon: '💡', text: 'objects - light bulb' },
	{ icon: '🔦', text: 'objects - flashlight' },
	{ icon: '🏮', text: 'objects - red paper lantern' },
	{ icon: '🪔', text: 'objects - diya lamp' },
	{ icon: '📔', text: 'objects - notebook with decorative cover' },
	{ icon: '📕', text: 'objects - closed book' },
	{ icon: '📖', text: 'objects - open book' },
	{ icon: '📗', text: 'objects - green book' },
	{ icon: '📘', text: 'objects - blue book' },
	{ icon: '📙', text: 'objects - orange book' },
	{ icon: '📚', text: 'objects - books' },
	{ icon: '📓', text: 'objects - notebook' },
	{ icon: '📒', text: 'objects - ledger' },
	{ icon: '📃', text: 'objects - page with curl' },
	{ icon: '📜', text: 'objects - scroll' },
	{ icon: '📄', text: 'objects - page facing up' },
	{ icon: '📰', text: 'objects - newspaper' },
	{ icon: '🗞', text: 'objects - rolled-up newspaper' },
	{ icon: '📑', text: 'objects - bookmark tabs' },
	{ icon: '🔖', text: 'objects - bookmark' },
	{ icon: '🏷', text: 'objects - label' },
	{ icon: '💰', text: 'objects - money bag' },
	{ icon: '💴', text: 'objects - yen banknote' },
	{ icon: '💵', text: 'objects - dollar banknote' },
	{ icon: '💶', text: 'objects - euro banknote' },
	{ icon: '💷', text: 'objects - pound banknote' },
	{ icon: '💸', text: 'objects - money with wings' },
	{ icon: '💳', text: 'objects - credit card' },
	{ icon: '🧾', text: 'objects - receipt' },
	{ icon: '💹', text: 'objects - chart increasing with yen' },
	{ icon: '💱', text: 'objects - currency exchange קניות' },
	{ icon: '💲', text: 'objects - heavy dollar sign כסף money קניות' },
	{ icon: '✉', text: 'objects - envelope' },
	{ icon: '📧', text: 'objects - e-mail' },
	{ icon: '📨', text: 'objects - incoming envelope' },
	{ icon: '📩', text: 'objects - envelope with arrow' },
	{ icon: '📤', text: 'objects - outbox tray' },
	{ icon: '📥', text: 'objects - inbox tray' },
	{ icon: '📦', text: 'objects - package' },
	{ icon: '📫', text: 'objects - closed mailbox with raised flag' },
	{ icon: '📪', text: 'objects - closed mailbox with lowered flag' },
	{ icon: '📬', text: 'objects - open mailbox with raised flag' },
	{ icon: '📭', text: 'objects - open mailbox with lowered flag' },
	{ icon: '📮', text: 'objects - postbox' },
	{ icon: '🗳', text: 'objects - ballot box with ballot' },
	{ icon: '✏', text: 'objects - pencil' },
	{ icon: '✒', text: 'objects - black nib' },
	{ icon: '🖋', text: 'objects - fountain pen' },
	{ icon: '🖊', text: 'objects - pen' },
	{ icon: '🖌', text: 'objects - paintbrush' },
	{ icon: '🖍', text: 'objects - crayon' },
	{ icon: '📝', text: 'objects - memo' },
	{ icon: '💼', text: 'objects - briefcase' },
	{ icon: '📁', text: 'objects - file folder' },
	{ icon: '📂', text: 'objects - open file folder' },
	{ icon: '🗂', text: 'objects - card index dividers' },
	{ icon: '📅', text: 'objects - calendar' },
	{ icon: '📆', text: 'objects - tear-off calendar' },
	{ icon: '🗒', text: 'objects - spiral notepad' },
	{ icon: '🗓', text: 'objects - spiral calendar' },
	{ icon: '📇', text: 'objects - card index' },
	{ icon: '📈', text: 'objects - chart increasing' },
	{ icon: '📉', text: 'objects - chart decreasing' },
	{ icon: '📊', text: 'objects - bar chart' },
	{ icon: '📋', text: 'objects - clipboard' },
	{ icon: '📌', text: 'objects - pushpin' },
	{ icon: '📍', text: 'objects - round pushpin' },
	{ icon: '📎', text: 'objects - paperclip' },
	{ icon: '🖇', text: 'objects - linked paperclips' },
	{ icon: '📏', text: 'objects - straight ruler' },
	{ icon: '📐', text: 'objects - triangular ruler' },
	{ icon: '✂', text: 'objects - scissors' },
	{ icon: '🗃', text: 'objects - card file box' },
	{ icon: '🗄', text: 'objects - file cabinet' },
	{ icon: '🗑', text: 'objects - wastebasket' },
	{ icon: '🔒', text: 'objects - locked' },
	{ icon: '🔓', text: 'objects - unlocked' },
	{ icon: '🔏', text: 'objects - locked with pen' },
	{ icon: '🔐', text: 'objects - locked with key' },
	{ icon: '🔑', text: 'objects - key' },
	{ icon: '🗝', text: 'objects - old key' },
	{ icon: '🔨', text: 'objects - hammer' },
	{ icon: '🪓', text: 'objects - axe' },
	{ icon: '⛏', text: 'objects - pick' },
	{ icon: '⚒', text: 'objects - hammer and pick' },
	{ icon: '🛠', text: 'objects - hammer and wrench' },
	{ icon: '🗡', text: 'objects - dagger' },
	{ icon: '⚔', text: 'objects - crossed swords' },
	{ icon: '🔫', text: 'objects - pistol' },
	{ icon: '🏹', text: 'objects - bow and arrow' },
	{ icon: '🛡', text: 'objects - shield' },
	{ icon: '🔧', text: 'objects - wrench' },
	{ icon: '🔩', text: 'objects - nut and bolt' },
	{ icon: '⚙', text: 'objects - gear' },
	{ icon: '🗜', text: 'objects - clamp' },
	{ icon: '⚖', text: 'objects - balance scale' },
	{ icon: '🦯', text: 'objects - probing cane' },
	{ icon: '🔗', text: 'objects - link' },
	{ icon: '⛓', text: 'objects - chains' },
	{ icon: '🧰', text: 'objects - toolbox' },
	{ icon: '🧲', text: 'objects - magnet' },
	{ icon: '⚗', text: 'objects - alembic' },
	{ icon: '🧪', text: 'objects - test tube' },
	{ icon: '🧫', text: 'objects - petri dish' },
	{ icon: '🧬', text: 'objects - dna' },
	{ icon: '🔬', text: 'objects - microscope' },
	{ icon: '🔭', text: 'objects - telescope' },
	{ icon: '📡', text: 'objects - satellite antenna' },
	{ icon: '💉', text: 'objects - syringe' },
	{ icon: '🩸', text: 'objects - drop of blood' },
	{ icon: '💊', text: 'objects - pill' },
	{ icon: '🩹', text: 'objects - adhesive bandage' },
	{ icon: '🩺', text: 'objects - stethoscope' },
	{ icon: '🚪', text: 'objects - door' },
	{ icon: '🛏', text: 'objects - bed' },
	{ icon: '🛋', text: 'objects - couch and lamp' },
	{ icon: '🪑', text: 'objects - chair' },
	{ icon: '🚽', text: 'objects - toilet' },
	{ icon: '🚿', text: 'objects - shower' },
	{ icon: '🛁', text: 'objects - bathtub' },
	{ icon: '🪒', text: 'objects - razor' },
	{ icon: '🧴', text: 'objects - lotion bottle' },
	{ icon: '🧷', text: 'objects - safety pin' },
	{ icon: '🧹', text: 'objects - broom' },
	{ icon: '🧺', text: 'objects - basket' },
	{ icon: '🧻', text: 'objects - roll of paper' },
	{ icon: '🧼', text: 'objects - soap' },
	{ icon: '🧽', text: 'objects - sponge' },
	{ icon: '🧯', text: 'objects - fire extinguisher' },
	{ icon: '🛒', text: 'objects - shopping cart קניות stores malls חנויות מרכזי קניות' },
	{ icon: '🚬', text: 'objects - cigarette' },
	{ icon: '⚰', text: 'objects - coffin' },
	{ icon: '⚱', text: 'objects - funeral urn' },
	{ icon: '🗿', text: 'objects - moai' },
	{ icon: '🏧', text: 'symbols - ATM sign' },
	{ icon: '🚮', text: 'symbols - litter in bin sign' },
	{ icon: '🚰', text: 'symbols - potable water' },
	{ icon: '♿', text: 'symbols - wheelchair symbol' },
	{ icon: '🚹', text: 'symbols - men’s room' },
	{ icon: '🚺', text: 'symbols - women’s room' },
	{ icon: '🚻', text: 'symbols - restroom' },
	{ icon: '🚼', text: 'symbols - baby symbol' },
	{ icon: '🚾', text: 'symbols - water closet' },
	{ icon: '🛂', text: 'symbols - passport control' },
	{ icon: '🛃', text: 'symbols - customs' },
	{ icon: '🛄', text: 'symbols - baggage claim' },
	{ icon: '🛅', text: 'symbols - left luggage' },
	{ icon: '⚠', text: 'symbols - warning' },
	{ icon: '🚸', text: 'symbols - children crossing' },
	{ icon: '⛔', text: 'symbols - no entry' },
	{ icon: '🚫', text: 'symbols - prohibited' },
	{ icon: '🚳', text: 'symbols - no bicycles' },
	{ icon: '🚭', text: 'symbols - no smoking' },
	{ icon: '🚯', text: 'symbols - no littering' },
	{ icon: '🚱', text: 'symbols - non-potable water' },
	{ icon: '🚷', text: 'symbols - no pedestrians' },
	{ icon: '📵', text: 'symbols - no mobile phones' },
	{ icon: '🔞', text: 'symbols - no one under eighteen' },
	{ icon: '☢', text: 'symbols - radioactive' },
	{ icon: '☣', text: 'symbols - biohazard' },
	{ icon: '⬆', text: 'symbols - up arrow' },
	{ icon: '↗', text: 'symbols - up-right arrow' },
	{ icon: '➡', text: 'symbols - right arrow' },
	{ icon: '↘', text: 'symbols - down-right arrow' },
	{ icon: '⬇', text: 'symbols - down arrow' },
	{ icon: '↙', text: 'symbols - down-left arrow' },
	{ icon: '⬅', text: 'symbols - left arrow' },
	{ icon: '↖', text: 'symbols - up-left arrow' },
	{ icon: '↕', text: 'symbols - up-down arrow' },
	{ icon: '↩', text: 'symbols - right arrow curving left' },
	{ icon: '↪', text: 'symbols - left arrow curving right' },
	{ icon: '⤴', text: 'symbols - right arrow curving up' },
	{ icon: '⤵', text: 'symbols - right arrow curving down' },
	{ icon: '🔃', text: 'symbols - clockwise vertical arrows' },
	{ icon: '🔄', text: 'symbols - counterclockwise arrows button' },
	{ icon: '🔙', text: 'symbols - BACK arrow' },
	{ icon: '🔚', text: 'symbols - END arrow' },
	{ icon: '🔛', text: 'symbols - ON! arrow' },
	{ icon: '🔜', text: 'symbols - SOON arrow' },
	{ icon: '🔝', text: 'symbols - TOP arrow' },
	{ icon: '🛐', text: 'symbols - place of worship' },
	{ icon: '⚛', text: 'symbols - atom symbol' },
	{ icon: '🕉', text: 'symbols - om' },
	{ icon: '✡', text: 'symbols - star of David' },
	{ icon: '☸', text: 'symbols - wheel of dharma' },
	{ icon: '☯', text: 'symbols - yin yang' },
	{ icon: '✝', text: 'symbols - latin cross' },
	{ icon: '☦', text: 'symbols - orthodox cross' },
	{ icon: '☪', text: 'symbols - star and crescent' },
	{ icon: '☮', text: 'symbols - peace symbol' },
	{ icon: '🕎', text: 'symbols - menorah' },
	{ icon: '🔯', text: 'symbols - dotted six-pointed star' },
	{ icon: '♈', text: 'symbols - Aries' },
	{ icon: '♉', text: 'symbols - Taurus' },
	{ icon: '♊', text: 'symbols - Gemini' },
	{ icon: '♋', text: 'symbols - Cancer' },
	{ icon: '♌', text: 'symbols - Leo' },
	{ icon: '♍', text: 'symbols - Virgo' },
	{ icon: '♎', text: 'symbols - Libra' },
	{ icon: '♏', text: 'symbols - Scorpio' },
	{ icon: '♐', text: 'symbols - Sagittarius' },
	{ icon: '♑', text: 'symbols - Capricorn' },
	{ icon: '♒', text: 'symbols - Aquarius' },
	{ icon: '♓', text: 'symbols - Pisces' },
	{ icon: '⛎', text: 'symbols - Ophiuchus' },
	{ icon: '🔀', text: 'symbols - shuffle tracks button' },
	{ icon: '🔁', text: 'symbols - repeat button' },
	{ icon: '🔂', text: 'symbols - repeat single button' },
	{ icon: '▶', text: 'symbols - play button' },
	{ icon: '⏩', text: 'symbols - fast-forward button' },
	{ icon: '⏭', text: 'symbols - next track button' },
	{ icon: '⏯', text: 'symbols - play or pause button' },
	{ icon: '◀', text: 'symbols - reverse button' },
	{ icon: '⏪', text: 'symbols - fast reverse button' },
	{ icon: '⏮', text: 'symbols - last track button' },
	{ icon: '🔼', text: 'symbols - upwards button' },
	{ icon: '⏫', text: 'symbols - fast up button' },
	{ icon: '🔽', text: 'symbols - downwards button' },
	{ icon: '⏬', text: 'symbols - fast down button' },
	{ icon: '⏸', text: 'symbols - pause button' },
	{ icon: '⏹', text: 'symbols - stop button' },
	{ icon: '⏺', text: 'symbols - record button' },
	{ icon: '⏏', text: 'symbols - eject button' },
	{ icon: '🎦', text: 'symbols - cinema' },
	{ icon: '🔅', text: 'symbols - dim button' },
	{ icon: '🔆', text: 'symbols - bright button' },
	{ icon: '📶', text: 'symbols - antenna bars' },
	{ icon: '📳', text: 'symbols - vibration mode' },
	{ icon: '📴', text: 'symbols - mobile phone off' },
	{ icon: '♀', text: 'symbols - female sign' },
	{ icon: '♂', text: 'symbols - male sign' },
	{ icon: '⚕', text: 'symbols - medical symbol' },
	{ icon: '♾', text: 'symbols - infinity' },
	{ icon: '♻', text: 'symbols - recycling symbol' },
	{ icon: '⚜', text: 'symbols - fleur-de-lis' },
	{ icon: '🔱', text: 'symbols - trident emblem' },
	{ icon: '📛', text: 'symbols - name badge' },
	{ icon: '🔰', text: 'symbols - Japanese symbol for beginner' },
	{ icon: '⭕', text: 'symbols - hollow red circle' },
	{ icon: '✅', text: 'symbols - check mark button success ok green v' },
	{ icon: '☑', text: 'symbols - check box with check' },
	{ icon: '✔', text: 'symbols - check mark' },
	{ icon: '✖', text: 'symbols - multiplication sign' },
	{ icon: '❌', text: 'symbols - cross mark x invalid no red' },
	{ icon: '❎', text: 'symbols - cross mark button error green x' },
	{ icon: '➕', text: 'symbols - plus sign' },
	{ icon: '➖', text: 'symbols - minus sign' },
	{ icon: '➗', text: 'symbols - division sign' },
	{ icon: '➰', text: 'symbols - curly loop' },
	{ icon: '➿', text: 'symbols - double curly loop' },
	{ icon: '〽', text: 'symbols - part alternation mark' },
	{ icon: '✳', text: 'symbols - eight-spoked asterisk' },
	{ icon: '✴', text: 'symbols - eight-pointed star' },
	{ icon: '❇', text: 'symbols - sparkle' },
	{ icon: '‼', text: 'symbols - double exclamation mark' },
	{ icon: '⁉', text: 'symbols - exclamation question mark' },
	{ icon: '❓', text: 'symbols - question mark' },
	{ icon: '❔', text: 'symbols - white question mark' },
	{ icon: '❕', text: 'symbols - white exclamation mark' },
	{ icon: '❗', text: 'symbols - exclamation mark' },
	{ icon: '〰', text: 'symbols - wavy dash' },
	{ icon: '#️⃣', text: 'symbols - keycap: #' },
	{ icon: '*️⃣', text: 'symbols - keycap: *' },
	{ icon: '0️⃣', text: 'symbols - keycap: 0' },
	{ icon: '1️⃣', text: 'symbols - keycap: 1' },
	{ icon: '2️⃣', text: 'symbols - keycap: 2' },
	{ icon: '3️⃣', text: 'symbols - keycap: 3' },
	{ icon: '4️⃣', text: 'symbols - keycap: 4' },
	{ icon: '5️⃣', text: 'symbols - keycap: 5' },
	{ icon: '6️⃣', text: 'symbols - keycap: 6' },
	{ icon: '7️⃣', text: 'symbols - keycap: 7' },
	{ icon: '8️⃣', text: 'symbols - keycap: 8' },
	{ icon: '9️⃣', text: 'symbols - keycap: 9' },
	{ icon: '🔟', text: 'symbols - keycap: 10' },
	{ icon: '🔠', text: 'symbols - input latin uppercase' },
	{ icon: '🔡', text: 'symbols - input latin lowercase' },
	{ icon: '🔢', text: 'symbols - input numbers' },
	{ icon: '🔣', text: 'symbols - input symbols' },
	{ icon: '🔤', text: 'symbols - input latin letters' },
	{ icon: '🅰', text: 'symbols - A button (blood type)' },
	{ icon: '🆎', text: 'symbols - AB button (blood type)' },
	{ icon: '🅱', text: 'symbols - B button (blood type)' },
	{ icon: '🆑', text: 'symbols - CL button' },
	{ icon: '🆒', text: 'symbols - COOL button' },
	{ icon: '🆓', text: 'symbols - FREE button' },
	{ icon: 'ℹ', text: 'symbols - information' },
	{ icon: '🆔', text: 'symbols - ID button' },
	{ icon: 'Ⓜ', text: 'symbols - circled M' },
	{ icon: '🆕', text: 'symbols - NEW button' },
	{ icon: '🆖', text: 'symbols - NG button' },
	{ icon: '🅾', text: 'symbols - O button (blood type)' },
	{ icon: '🆗', text: 'symbols - OK button' },
	{ icon: '🅿', text: 'symbols - P button' },
	{ icon: '🆘', text: 'symbols - SOS button' },
	{ icon: '🆙', text: 'symbols - UP! button' },
	{ icon: '🆚', text: 'symbols - VS button' },
	{ icon: '🈁', text: 'symbols - Japanese “here” button' },
	{ icon: '🈂', text: 'symbols - Japanese “service charge” button' },
	{ icon: '🈷', text: 'symbols - Japanese “monthly amount” button' },
	{ icon: '🈶', text: 'symbols - Japanese “not free of charge” button' },
	{ icon: '🈯', text: 'symbols - Japanese “reserved” button' },
	{ icon: '🉐', text: 'symbols - Japanese “bargain” button' },
	{ icon: '🈹', text: 'symbols - Japanese “discount” button' },
	{ icon: '🈚', text: 'symbols - Japanese “free of charge” button' },
	{ icon: '🈲', text: 'symbols - Japanese “prohibited” button' },
	{ icon: '🉑', text: 'symbols - Japanese “acceptable” button' },
	{ icon: '🈸', text: 'symbols - Japanese “application” button' },
	{ icon: '🈴', text: 'symbols - Japanese “passing grade” button' },
	{ icon: '🈳', text: 'symbols - Japanese “vacancy” button' },
	{ icon: '㊗', text: 'symbols - Japanese “congratulations” button' },
	{ icon: '㊙', text: 'symbols - Japanese “secret” button' },
	{ icon: '🈺', text: 'symbols - Japanese “open for business” button' },
	{ icon: '🈵', text: 'symbols - Japanese “no vacancy” button' },
	{ icon: '🔴', text: 'symbols - red circle' },
	{ icon: '🟠', text: 'symbols - orange circle' },
	{ icon: '🟡', text: 'symbols - yellow circle' },
	{ icon: '🟢', text: 'symbols - green circle' },
	{ icon: '🔵', text: 'symbols - blue circle' },
	{ icon: '🟣', text: 'symbols - purple circle' },
	{ icon: '🟤', text: 'symbols - brown circle' },
	{ icon: '⚫', text: 'symbols - black circle general' },
	{ icon: '⚪', text: 'symbols - white circle' },
	{ icon: '🟥', text: 'symbols - red square' },
	{ icon: '🟧', text: 'symbols - orange square' },
	{ icon: '🟨', text: 'symbols - yellow square' },
	{ icon: '🟩', text: 'symbols - green square' },
	{ icon: '🟦', text: 'symbols - blue square' },
	{ icon: '🟪', text: 'symbols - purple square' },
	{ icon: '🟫', text: 'symbols - brown square' },
	{ icon: '⬛', text: 'symbols - black large square' },
	{ icon: '⬜', text: 'symbols - white large square' },
	{ icon: '◼', text: 'symbols - black medium square' },
	{ icon: '◻', text: 'symbols - white medium square' },
	{ icon: '◾', text: 'symbols - black medium-small square' },
	{ icon: '◽', text: 'symbols - white medium-small square' },
	{ icon: '▪', text: 'symbols - black small square' },
	{ icon: '▫', text: 'symbols - white small square' },
	{ icon: '🔶', text: 'symbols - large orange diamond' },
	{ icon: '🔷', text: 'symbols - large blue diamond' },
	{ icon: '🔸', text: 'symbols - small orange diamond' },
	{ icon: '🔹', text: 'symbols - small blue diamond' },
	{ icon: '🔺', text: 'symbols - red triangle pointed up' },
	{ icon: '🔻', text: 'symbols - red triangle pointed down' },
	{ icon: '💠', text: 'symbols - diamond with a dot' },
	{ icon: '🔘', text: 'symbols - radio button' },
	{ icon: '🔳', text: 'symbols - white square button' },
	{ icon: '🔲', text: 'symbols - black square button' },
	{ icon: '🏁', text: 'flags - chequered flag' },
	{ icon: '🚩', text: 'flags - triangular flag' },
	{ icon: '🎌', text: 'flags - crossed flags' },
	{ icon: '🏴', text: 'flags - black flag' },
	{ icon: '🏳', text: 'flags - white flag' },
	{ icon: '🏳️‍🌈', text: 'flags - rainbow flag' },
	{ icon: '🏴‍☠️', text: 'flags - pirate flag' },
	{ icon: '🇦🇨', text: 'flags - flag: Ascension Island אי האסנסנס' },
	{ icon: '🇦🇩', text: 'flags - flag: Andorra אנדורה' },
	{ icon: '🇦🇪', text: 'flags - flag: United Arab Emirates איחוד האמירויות הערביות' },
	{ icon: '🇦🇫', text: 'flags - flag: Afghanistan אפגניסטן' },
	{ icon: '🇦🇬', text: 'flags - flag: Antigua & Barbuda אנטיגואה & ברבודה' },
	{ icon: '🇦🇮', text: 'flags - flag: Anguilla אנגווילה' },
	{ icon: '🇦🇱', text: 'flags - flag: Albania אלבניה' },
	{ icon: '🇦🇲', text: 'flags - flag: Armenia אַרְמֶנִיָה' },
	{ icon: '🇦🇴', text: 'flags - flag: Angola אנגולה' },
	{ icon: '🇦🇶', text: 'flags - flag: Antarctica אנטארקטיקה' },
	{ icon: '🇦🇷', text: 'flags - flag: Argentina ארגנטינה' },
	{ icon: '🇦🇸', text: 'flags - flag: American Samoa סמואה האמריקנית' },
	{ icon: '🇦🇹', text: 'flags - flag: Austria אוֹסְטְרֵיָה' },
	{ icon: '🇦🇺', text: 'flags - flag: Australia אוֹסטְרַלִיָה' },
	{ icon: '🇦🇼', text: 'flags - flag: Aruba ארובה' },
	{ icon: '🇦🇽', text: 'flags - flag: Åland Islands איי אלנד' },
	{ icon: '🇦🇿', text: "flags - flag: Azerbaijan אזרבייג'ן" },
	{ icon: '🇧🇦', text: 'flags - flag: Bosnia & Herzegovina בוסניה & הרצגובינה' },
	{ icon: '🇧🇧', text: 'flags - flag: Barbados ברבדוס' },
	{ icon: '🇧🇩', text: 'flags - flag: Bangladesh בנגלדש' },
	{ icon: '🇧🇪', text: 'flags - flag: Belgium בלגיה' },
	{ icon: '🇧🇫', text: 'flags - flag: Burkina Faso בורקינה פאסו' },
	{ icon: '🇧🇬', text: 'flags - flag: Bulgaria בולגריה' },
	{ icon: '🇧🇭', text: 'flags - flag: Bahrain בחריין' },
	{ icon: '🇧🇮', text: 'flags - flag: Burundi בורונדי' },
	{ icon: '🇧🇯', text: 'flags - flag: Benin בנין' },
	{ icon: '🇧🇱', text: "flags - flag: St. Barthélemy סנט ברת'למי" },
	{ icon: '🇧🇲', text: 'flags - flag: Bermuda ברמודה' },
	{ icon: '🇧🇳', text: 'flags - flag: Brunei ברוניי' },
	{ icon: '🇧🇴', text: 'flags - flag: Bolivia בוליביה' },
	{ icon: '🇧🇶', text: 'flags - flag: Caribbean Netherlands הולנד הקאריבית' },
	{ icon: '🇧🇷', text: 'flags - flag: Brazil בְּרָזִיל' },
	{ icon: '🇧🇸', text: 'flags - flag: Bahamas איי בהאמה' },
	{ icon: '🇧🇹', text: 'flags - flag: Bhutan בהוטן' },
	{ icon: '🇧🇻', text: 'flags - flag: Bouvet Island האי בובה' },
	{ icon: '🇧🇼', text: 'flags - flag: Botswana בוצואנה' },
	{ icon: '🇧🇾', text: 'flags - flag: Belarus בלארוס' },
	{ icon: '🇧🇿', text: 'flags - flag: Belize בליז' },
	{ icon: '🇨🇦', text: 'flags - flag: Canada קנדה' },
	{ icon: '🇨🇨', text: 'flags - flag: Cocos (Keeling) Islands איי קוקוס (קילינג).' },
	{ icon: '🇨🇩', text: 'flags - flag: Congo – Kinshasa קונגו - קינשאסה' },
	{ icon: '🇨🇫', text: 'flags - flag: Central African Republic הרפובליקה המרכז - אפריקאית' },
	{ icon: '🇨🇬', text: 'flags - flag: Congo – Brazzaville קונגו - ברזוויל' },
	{ icon: '🇨🇭', text: 'flags - flag: Switzerland שוויץ' },
	{ icon: '🇨🇮', text: 'flags - flag: Côte d’Ivoire חוף השנהב' },
	{ icon: '🇨🇰', text: 'flags - flag: Cook Islands איי קוק' },
	{ icon: '🇨🇱', text: "flags - flag: Chile צ'ילה" },
	{ icon: '🇨🇲', text: 'flags - flag: Cameroon קמרון' },
	{ icon: '🇨🇳', text: 'flags - flag: China חרסינה' },
	{ icon: '🇨🇴', text: 'flags - flag: Colombia קולומביה' },
	{ icon: '🇨🇵', text: 'flags - flag: Clipperton Island האי קליפרטון' },
	{ icon: '🇨🇷', text: 'flags - flag: Costa Rica קוסטה ריקה' },
	{ icon: '🇨🇺', text: 'flags - flag: Cuba קובה' },
	{ icon: '🇨🇻', text: 'flags - flag: Cape Verde קייפ ורדה' },
	{ icon: '🇨🇼', text: 'flags - flag: Curaçao קוראסאו' },
	{ icon: '🇨🇽', text: 'flags - flag: Christmas Island אי חג המולד' },
	{ icon: '🇨🇾', text: 'flags - flag: Cyprus קַפרִיסִין' },
	{ icon: '🇨🇿', text: "flags - flag: Czechia צ'כיה" },
	{ icon: '🇩🇪', text: 'flags - flag: Germany גֶרמָנִיָה' },
	{ icon: '🇩🇬', text: 'flags - flag: Diego Garcia דייגו גרסיה' },
	{ icon: '🇩🇯', text: "flags - flag: Djibouti ג'יבוטי" },
	{ icon: '🇩🇰', text: 'flags - flag: Denmark דנמרק' },
	{ icon: '🇩🇲', text: 'flags - flag: Dominica דומיניקה' },
	{ icon: '🇩🇴', text: 'flags - flag: Dominican Republic הרפובליקה הדומיניקנית' },
	{ icon: '🇩🇿', text: "flags - flag: Algeria אלג'יריה" },
	{ icon: '🇪🇦', text: 'flags - flag: Ceuta & Melilla Ceuta & מלילה' },
	{ icon: '🇪🇨', text: 'flags - flag: Ecuador אקוודור' },
	{ icon: '🇪🇪', text: 'flags - flag: Estonia אסטוניה' },
	{ icon: '🇪🇬', text: 'flags - flag: Egypt מִצְרַיִם' },
	{ icon: '🇪🇭', text: 'flags - flag: Western Sahara סהרה המערבית' },
	{ icon: '🇪🇷', text: 'flags - flag: Eritrea אריתריאה' },
	{ icon: '🇪🇸', text: 'flags - flag: Spain סְפָרַד' },
	{ icon: '🇪🇹', text: 'flags - flag: Ethiopia אֶתִיוֹפִּיָה' },
	{ icon: '🇪🇺', text: 'flags - flag: European Union האיחוד האירופאי' },
	{ icon: '🇫🇮', text: 'flags - flag: Finland פינלנד' },
	{ icon: '🇫🇯', text: "flags - flag: Fiji פיג'י" },
	{ icon: '🇫🇰', text: 'flags - flag: Falkland Islands איי פוקלנד' },
	{ icon: '🇫🇲', text: 'flags - flag: Micronesia מיקרונזיה' },
	{ icon: '🇫🇴', text: 'flags - flag: Faroe Islands איי פרו' },
	{ icon: '🇫🇷', text: 'flags - flag: France צָרְפַת' },
	{ icon: '🇬🇦', text: 'flags - flag: Gabon גאבון' },
	{ icon: '🇬🇧', text: 'flags - flag: United Kingdom הממלכה המאוחדת' },
	{ icon: '🇬🇩', text: 'flags - flag: Grenada גרנדה' },
	{ icon: '🇬🇪', text: 'flags - flag: Georgia גאורגיה' },
	{ icon: '🇬🇫', text: 'flags - flag: French Guiana גיאנה הצרפתית' },
	{ icon: '🇬🇬', text: 'flags - flag: Guernsey גרנזי' },
	{ icon: '🇬🇭', text: 'flags - flag: Ghana גאנה' },
	{ icon: '🇬🇮', text: 'flags - flag: Gibraltar גיברלטר' },
	{ icon: '🇬🇱', text: 'flags - flag: Greenland גרינלנד' },
	{ icon: '🇬🇲', text: 'flags - flag: Gambia גמביה' },
	{ icon: '🇬🇳', text: 'flags - flag: Guinea גינאה' },
	{ icon: '🇬🇵', text: 'flags - flag: Guadeloupe גוואדלופ' },
	{ icon: '🇬🇶', text: 'flags - flag: Equatorial Guinea גיניאה המשוונית' },
	{ icon: '🇬🇷', text: 'flags - flag: Greece יָוָן' },
	{ icon: '🇬🇸', text: "flags - flag: South Georgia & South Sandwich Islands דרום ג'ורג'יה & איי סנדוויץ' הדרומיים" },
	{ icon: '🇬🇹', text: 'flags - flag: Guatemala גואטמלה' },
	{ icon: '🇬🇺', text: 'flags - flag: Guam גואם' },
	{ icon: '🇬🇼', text: 'flags - flag: Guinea-Bissau גינאה-ביסאו' },
	{ icon: '🇬🇾', text: 'flags - flag: Guyana גיאנה' },
	{ icon: '🇭🇰', text: 'flags - flag: Hong Kong SAR China הונג קונג SAR סין' },
	{ icon: '🇭🇲', text: 'flags - flag: Heard & McDonald Islands שמע & איי מקדונלד' },
	{ icon: '🇭🇳', text: 'flags - flag: Honduras הונדורס' },
	{ icon: '🇭🇷', text: 'flags - flag: Croatia קרואטיה' },
	{ icon: '🇭🇹', text: 'flags - flag: Haiti האיטי' },
	{ icon: '🇭🇺', text: 'flags - flag: Hungary הונגריה' },
	{ icon: '🇮🇨', text: 'flags - flag: Canary Islands האיים הקנריים' },
	{ icon: '🇮🇩', text: 'flags - flag: Indonesia אִינדוֹנֵזִיָה' },
	{ icon: '🇮🇪', text: 'flags - flag: Ireland אירלנד' },
	{ icon: '🇮🇱', text: 'flags - flag: Israel ישראל' },
	{ icon: '🇮🇲', text: 'flags - flag: Isle of Man האי מאן' },
	{ icon: '🇮🇳', text: 'flags - flag: India הוֹדוּ' },
	{ icon: '🇮🇴', text: 'flags - flag: British Indian Ocean Territory טריטוריית האוקיינוס ההודי הבריטי' },
	{ icon: '🇮🇶', text: 'flags - flag: Iraq עִירַאק' },
	{ icon: '🇮🇷', text: 'flags - flag: Iran איראן' },
	{ icon: '🇮🇸', text: 'flags - flag: Iceland אִיסלַנד' },
	{ icon: '🇮🇹', text: 'flags - flag: Italy אִיטַלִיָה' },
	{ icon: '🇯🇪', text: "flags - flag: Jersey ניו גרז'י" },
	{ icon: '🇯🇲', text: "flags - flag: Jamaica ג'מייקה" },
	{ icon: '🇯🇴', text: 'flags - flag: Jordan יַרדֵן' },
	{ icon: '🇯🇵', text: 'flags - flag: Japan יפן' },
	{ icon: '🇰🇪', text: 'flags - flag: Kenya קניה' },
	{ icon: '🇰🇬', text: 'flags - flag: Kyrgyzstan קירגיזסטן' },
	{ icon: '🇰🇭', text: 'flags - flag: Cambodia קמבודיה' },
	{ icon: '🇰🇮', text: 'flags - flag: Kiribati קיריבטי' },
	{ icon: '🇰🇲', text: 'flags - flag: Comoros קומורו' },
	{ icon: '🇰🇳', text: 'flags - flag: St. Kitts & Nevis St. Kitts & נוויס' },
	{ icon: '🇰🇵', text: 'flags - flag: North Korea צפון קוריאה' },
	{ icon: '🇰🇷', text: 'flags - flag: South Korea דרום קוריאה' },
	{ icon: '🇰🇼', text: 'flags - flag: Kuwait כווית' },
	{ icon: '🇰🇾', text: 'flags - flag: Cayman Islands איי קיימן' },
	{ icon: '🇰🇿', text: 'flags - flag: Kazakhstan קזחסטן' },
	{ icon: '🇱🇦', text: 'flags - flag: Laos לאוס' },
	{ icon: '🇱🇧', text: 'flags - flag: Lebanon לבנון' },
	{ icon: '🇱🇨', text: 'flags - flag: St. Lucia סנט לוסיה' },
	{ icon: '🇱🇮', text: 'flags - flag: Liechtenstein ליכטנשטיין' },
	{ icon: '🇱🇰', text: 'flags - flag: Sri Lanka סרי לנקה' },
	{ icon: '🇱🇷', text: 'flags - flag: Liberia ליבריה' },
	{ icon: '🇱🇸', text: 'flags - flag: Lesotho לסוטו' },
	{ icon: '🇱🇹', text: 'flags - flag: Lithuania ליטא' },
	{ icon: '🇱🇺', text: 'flags - flag: Luxembourg לוקסמבורג' },
	{ icon: '🇱🇻', text: 'flags - flag: Latvia לטביה' },
	{ icon: '🇱🇾', text: 'flags - flag: Libya לוב' },
	{ icon: '🇲🇦', text: 'flags - flag: Morocco מָרוֹקוֹ' },
	{ icon: '🇲🇨', text: 'flags - flag: Monaco מונקו' },
	{ icon: '🇲🇩', text: 'flags - flag: Moldova מולדובה' },
	{ icon: '🇲🇪', text: 'flags - flag: Montenegro מונטנגרו' },
	{ icon: '🇲🇫', text: 'flags - flag: St. Martin סנט מרטין' },
	{ icon: '🇲🇬', text: 'flags - flag: Madagascar מדגסקר' },
	{ icon: '🇲🇭', text: 'flags - flag: Marshall Islands איי מרשל' },
	{ icon: '🇲🇰', text: 'flags - flag: North Macedonia צפון מקדוניה' },
	{ icon: '🇲🇱', text: 'flags - flag: Mali מלי' },
	{ icon: '🇲🇲', text: 'flags - flag: Myanmar (Burma) מיאנמר (בורמה)' },
	{ icon: '🇲🇳', text: 'flags - flag: Mongolia מונגוליה' },
	{ icon: '🇲🇴', text: 'flags - flag: Macao SAR China Macao SAR סין' },
	{ icon: '🇲🇵', text: 'flags - flag: Northern Mariana Islands איי מריאנה הצפוניים' },
	{ icon: '🇲🇶', text: 'flags - flag: Martinique מרטיניק' },
	{ icon: '🇲🇷', text: 'flags - flag: Mauritania מאוריטניה' },
	{ icon: '🇲🇸', text: 'flags - flag: Montserrat מונטסראט' },
	{ icon: '🇲🇹', text: 'flags - flag: Malta מלטה' },
	{ icon: '🇲🇺', text: 'flags - flag: Mauritius מאוריציוס' },
	{ icon: '🇲🇻', text: 'flags - flag: Maldives האיים המלדיביים האיים המלדיבים' },
	{ icon: '🇲🇼', text: 'flags - flag: Malawi מלאווי' },
	{ icon: '🇲🇽', text: 'flags - flag: Mexico מקסיקו' },
	{ icon: '🇲🇾', text: 'flags - flag: Malaysia מלזיה' },
	{ icon: '🇲🇿', text: 'flags - flag: Mozambique מוזמביק' },
	{ icon: '🇳🇦', text: 'flags - flag: Namibia נמיביה' },
	{ icon: '🇳🇨', text: 'flags - flag: New Caledonia קלדוניה החדשה' },
	{ icon: '🇳🇪', text: "flags - flag: Niger ניז'ר" },
	{ icon: '🇳🇫', text: 'flags - flag: Norfolk Island האי נורפוק' },
	{ icon: '🇳🇬', text: 'flags - flag: Nigeria ניגריה' },
	{ icon: '🇳🇮', text: 'flags - flag: Nicaragua ניקרגואה' },
	{ icon: '🇳🇱', text: 'flags - flag: Netherlands הולנד' },
	{ icon: '🇳🇴', text: 'flags - flag: Norway נורווגיה' },
	{ icon: '🇳🇵', text: 'flags - flag: Nepal נפאל' },
	{ icon: '🇳🇷', text: 'flags - flag: Nauru נאורו' },
	{ icon: '🇳🇺', text: 'flags - flag: Niue ניואה' },
	{ icon: '🇳🇿', text: 'flags - flag: New Zealand ניו זילנד' },
	{ icon: '🇴🇲', text: 'flags - flag: Oman עומאן' },
	{ icon: '🇵🇦', text: 'flags - flag: Panama פנמה' },
	{ icon: '🇵🇪', text: 'flags - flag: Peru פרו' },
	{ icon: '🇵🇫', text: 'flags - flag: French Polynesia פולינזיה הצרפתית' },
	{ icon: '🇵🇬', text: 'flags - flag: Papua New Guinea פפואה גינאה החדשה' },
	{ icon: '🇵🇭', text: 'flags - flag: Philippines פיליפינים' },
	{ icon: '🇵🇰', text: 'flags - flag: Pakistan פקיסטן' },
	{ icon: '🇵🇱', text: 'flags - flag: Poland פּוֹלִין' },
	{ icon: '🇵🇲', text: 'flags - flag: St. Pierre & Miquelon סנט פייר & מיקלון' },
	{ icon: '🇵🇳', text: 'flags - flag: Pitcairn Islands איי פיטקרן' },
	{ icon: '🇵🇷', text: 'flags - flag: Puerto Rico פוארטו ריקו' },
	{ icon: '🇵🇸', text: 'flags - flag: Palestinian Territories השטחים הפלסטיניים' },
	{ icon: '🇵🇹', text: 'flags - flag: Portugal פּוֹרטוּגָל' },
	{ icon: '🇵🇼', text: 'flags - flag: Palau פלאו' },
	{ icon: '🇵🇾', text: 'flags - flag: Paraguay פרגוואי' },
	{ icon: '🇶🇦', text: 'flags - flag: Qatar קטאר' },
	{ icon: '🇷🇪', text: 'flags - flag: Réunion איחוד' },
	{ icon: '🇷🇴', text: 'flags - flag: Romania רומניה' },
	{ icon: '🇷🇸', text: 'flags - flag: Serbia סרביה' },
	{ icon: '🇷🇺', text: 'flags - flag: Russia רוּסִיָה' },
	{ icon: '🇷🇼', text: 'flags - flag: Rwanda רואנדה' },
	{ icon: '🇸🇦', text: 'flags - flag: Saudi Arabia ערב הסעודית' },
	{ icon: '🇸🇧', text: 'flags - flag: Solomon Islands איי שלמה' },
	{ icon: '🇸🇨', text: 'flags - flag: Seychelles איי סיישל' },
	{ icon: '🇸🇩', text: 'flags - flag: Sudan סודן' },
	{ icon: '🇸🇪', text: 'flags - flag: Sweden שבדיה' },
	{ icon: '🇸🇬', text: 'flags - flag: Singapore סינגפור' },
	{ icon: '🇸🇭', text: 'flags - flag: St. Helena סנט הלנה' },
	{ icon: '🇸🇮', text: 'flags - flag: Slovenia סלובניה' },
	{ icon: '🇸🇯', text: 'flags - flag: Svalbard & Jan Mayen סבאלברד & יאן מאין' },
	{ icon: '🇸🇰', text: 'flags - flag: Slovakia סלובקיה' },
	{ icon: '🇸🇱', text: 'flags - flag: Sierra Leone סיירה לאון' },
	{ icon: '🇸🇲', text: 'flags - flag: San Marino סן מרינו' },
	{ icon: '🇸🇳', text: 'flags - flag: Senegal סנגל' },
	{ icon: '🇸🇴', text: 'flags - flag: Somalia סומליה' },
	{ icon: '🇸🇷', text: 'flags - flag: Suriname סורינאם' },
	{ icon: '🇸🇸', text: 'flags - flag: South Sudan דרום סודן' },
	{ icon: '🇸🇹', text: 'flags - flag: São Tomé & Príncipe סאו טומה & פרינסיפ' },
	{ icon: '🇸🇻', text: 'flags - flag: El Salvador אל סלבדור' },
	{ icon: '🇸🇽', text: 'flags - flag: Sint Maarten סנט מרטן' },
	{ icon: '🇸🇾', text: 'flags - flag: Syria סוּריָה' },
	{ icon: '🇸🇿', text: 'flags - flag: Eswatini אסווטיני' },
	{ icon: '🇹🇦', text: 'flags - flag: Tristan da Cunha טריסטן דה קוניה' },
	{ icon: '🇹🇨', text: 'flags - flag: Turks & Caicos Islands טורקים & איי קאיקוס' },
	{ icon: '🇹🇩', text: "flags - flag: Chad צ'אד" },
	{ icon: '🇹🇫', text: 'flags - flag: French Southern Territories השטחים הדרומיים של צרפת' },
	{ icon: '🇹🇬', text: 'flags - flag: Togo ללכת' },
	{ icon: '🇹🇭', text: 'flags - flag: Thailand תאילנד' },
	{ icon: '🇹🇯', text: "flags - flag: Tajikistan טג'יקיסטן" },
	{ icon: '🇹🇰', text: 'flags - flag: Tokelau טוקלאו' },
	{ icon: '🇹🇱', text: 'flags - flag: Timor-Leste טימור-לסטה' },
	{ icon: '🇹🇲', text: 'flags - flag: Turkmenistan טורקמניסטן' },
	{ icon: '🇹🇳', text: 'flags - flag: Tunisia תוניסיה' },
	{ icon: '🇹🇴', text: 'flags - flag: Tonga טונגה' },
	{ icon: '🇹🇷', text: 'flags - flag: Turkey טורקיה' },
	{ icon: '🇹🇹', text: 'flags - flag: Trinidad & Tobago טרינידד & טובגו' },
	{ icon: '🇹🇻', text: 'flags - flag: Tuvalu טובאלו' },
	{ icon: '🇹🇼', text: 'flags - flag: Taiwan טייוואן' },
	{ icon: '🇹🇿', text: 'flags - flag: Tanzania טנזניה' },
	{ icon: '🇺🇦', text: 'flags - flag: Ukraine אוקראינה' },
	{ icon: '🇺🇬', text: 'flags - flag: Uganda אוגנדה' },
	{ icon: '🇺🇲', text: 'flags - flag: U.S. Outlying Islands האיים המרוחקים של ארה"ב' },
	{ icon: '🇺🇳', text: 'flags - flag: United Nations האומות המאוחדות' },
	{ icon: '🇺🇸', text: 'flags - flag: United States ארצות הברית' },
	{ icon: '🇺🇾', text: 'flags - flag: Uruguay אורוגוואי' },
	{ icon: '🇺🇿', text: 'flags - flag: Uzbekistan אוזבקיסטן' },
	{ icon: '🇻🇦', text: 'flags - flag: Vatican City עיר הותיקן' },
	{ icon: '🇻🇨', text: 'flags - flag: St. Vincent & Grenadines סנט וינסנט & גרנדינים' },
	{ icon: '🇻🇪', text: 'flags - flag: Venezuela ונצואלה' },
	{ icon: '🇻🇬', text: 'flags - flag: British Virgin Islands איי בתולה בריטיים' },
	{ icon: '🇻🇮', text: 'flags - flag: U.S. Virgin Islands איי הבתולה של ארצות הברית' },
	{ icon: '🇻🇳', text: 'flags - flag: Vietnam וייטנאם' },
	{ icon: '🇻🇺', text: 'flags - flag: Vanuatu ונואטו' },
	{ icon: '🇼🇫', text: 'flags - flag: Wallis & Futuna Wallis & פוטונה' },
	{ icon: '🇼🇸', text: 'flags - flag: Samoa סמואה' },
	{ icon: '🇽🇰', text: 'flags - flag: Kosovo קוסובו' },
	{ icon: '🇾🇪', text: 'flags - flag: Yemen תֵימָן' },
	{ icon: '🇾🇹', text: 'flags - flag: Mayotte מיוט' },
	{ icon: '🇿🇦', text: 'flags - flag: South Africa דרום אפריקה' },
	{ icon: '🇿🇲', text: 'flags - flag: Zambia זמביה' },
	{ icon: '🇿🇼', text: 'flags - flag: Zimbabwe זימבבואה' },
	{ icon: '🏴󠁧󠁢󠁥󠁮󠁧󠁿', text: 'flags - flag: England אַנְגלִיָה' },
	{ icon: '🏴󠁧󠁢󠁳󠁣󠁴󠁿', text: 'flags - flag: Scotland סקוטלנד' },
	{ icon: '🏴󠁧󠁢󠁷󠁬󠁳󠁿', text: 'flags - flag: Wales ויילס' },

	// more
	{ icon: '😀', text: 'smiley' },
	{ icon: '😃', text: 'smiley' },
	{ icon: '😄', text: 'smiley' },
	{ icon: '😁', text: 'smiley' },
	{ icon: '😆', text: 'smiley' },
	{ icon: '😅', text: 'smiley' },
	{ icon: '😂', text: 'smiley' },
	{ icon: '🤣', text: 'smiley' },
	{ icon: '🥲', text: 'smiley' },
	{ icon: '🥹', text: 'smiley' },
	{ icon: '☺️', text: 'smiley' },
	{ icon: '😊', text: 'smiley' },
	{ icon: '😇', text: 'smiley' },
	{ icon: '🙂', text: 'smiley' },
	{ icon: '🙃', text: 'smiley' },
	{ icon: '😉', text: 'smiley' },
	{ icon: '😌', text: 'smiley' },
	{ icon: '😍', text: 'smiley' },
	{ icon: '🥰', text: 'smiley' },
	{ icon: '😘', text: 'smiley' },
	{ icon: '😗', text: 'smiley' },
	{ icon: '😙', text: 'smiley' },
	{ icon: '😚', text: 'smiley' },
	{ icon: '😋', text: 'smiley' },
	{ icon: '😛', text: 'smiley' },
	{ icon: '😝', text: 'smiley' },
	{ icon: '😜', text: 'smiley' },
	{ icon: '🤪', text: 'smiley' },
	{ icon: '🤨', text: 'smiley' },
	{ icon: '🧐', text: 'smiley' },
	{ icon: '🤓', text: 'smiley' },
	{ icon: '😎', text: 'smiley' },
	{ icon: '🥸', text: 'smiley' },
	{ icon: '🤩', text: 'smiley' },
	{ icon: '🥳', text: 'smiley' },
	{ icon: '😏', text: 'smiley' },
	{ icon: '😒', text: 'smiley' },
	{ icon: '😞', text: 'smiley' },
	{ icon: '😔', text: 'smiley' },
	{ icon: '😟', text: 'smiley' },
	{ icon: '😕', text: 'smiley' },
	{ icon: '🙁', text: 'smiley' },
	{ icon: '☹️', text: 'smiley' },
	{ icon: '😣', text: 'smiley' },
	{ icon: '😖', text: 'smiley' },
	{ icon: '😫', text: 'smiley' },
	{ icon: '😩', text: 'smiley' },
	{ icon: '🥺', text: 'smiley' },
	{ icon: '😢', text: 'smiley' },
	{ icon: '😭', text: 'smiley' },
	{ icon: '😮‍💨', text: 'smiley' },
	{ icon: '😤', text: 'smiley' },
	{ icon: '😠', text: 'smiley' },
	{ icon: '😡', text: 'smiley' },
	{ icon: '🤬', text: 'smiley' },
	{ icon: '🤯', text: 'smiley' },
	{ icon: '😳', text: 'smiley' },
	{ icon: '🥵', text: 'smiley' },
	{ icon: '🥶', text: 'smiley' },
	{ icon: '😱', text: 'smiley' },
	{ icon: '😨', text: 'smiley' },
	{ icon: '😰', text: 'smiley' },
	{ icon: '😥', text: 'smiley' },
	{ icon: '😓', text: 'smiley' },
	{ icon: '🫣', text: 'smiley' },
	{ icon: '🤗', text: 'smiley' },
	{ icon: '🫡', text: 'smiley' },
	{ icon: '🤔', text: 'smiley' },
	{ icon: '🫢', text: 'smiley' },
	{ icon: '🤭', text: 'smiley' },
	{ icon: '🤫', text: 'smiley' },
	{ icon: '🤥', text: 'smiley' },
	{ icon: '😶', text: 'smiley' },
	{ icon: '😶‍🌫️', text: 'smiley' },
	{ icon: '😐', text: 'smiley' },
	{ icon: '😑', text: 'smiley' },
	{ icon: '😬', text: 'smiley' },
	{ icon: '🫠', text: 'smiley' },
	{ icon: '🙄', text: 'smiley' },
	{ icon: '😯', text: 'smiley' },
	{ icon: '😦', text: 'smiley' },
	{ icon: '😧', text: 'smiley' },
	{ icon: '😮', text: 'smiley' },
	{ icon: '😲', text: 'smiley' },
	{ icon: '🥱', text: 'smiley' },
	{ icon: '😴', text: 'smiley' },
	{ icon: '🤤', text: 'smiley' },
	{ icon: '😪', text: 'smiley' },
	{ icon: '😵', text: 'smiley' },
	{ icon: '😵‍💫', text: 'smiley' },
	{ icon: '🫥', text: 'smiley סמיילי הפוך black upwards backwards' },
	{ icon: '🤐', text: 'smiley' },
	{ icon: '🥴', text: 'smiley' },
	{ icon: '🤢', text: 'smiley' },
	{ icon: '🤮', text: 'smiley' },
	{ icon: '🤧', text: 'smiley' },
	{ icon: '😷', text: 'smiley' },
	{ icon: '🤒', text: 'smiley' },
	{ icon: '🤕', text: 'smiley' },
	{ icon: '🤑', text: 'smiley' },
	{ icon: '🤠', text: 'smiley' },
	{ icon: '😈', text: 'smiley purple סגול' },
	{ icon: '👿', text: 'smiley' },
	{ icon: '👹', text: 'smiley' },
	{ icon: '👺', text: 'smiley' },
	{ icon: '🤡', text: 'smiley' },
	{ icon: '💩', text: 'smiley' },
	{ icon: '👻', text: 'smiley ghost boo' },
	{ icon: '💀', text: 'smiley skeleton pirate' },
	{ icon: '☠️', text: 'smiley skeleton pirate' },
	{ icon: '👽', text: 'smiley alien' },
	{ icon: '👾', text: 'smiley' },
	{ icon: '🤖', text: 'smiley' },
	{ icon: '🎃', text: 'smiley' },
	{ icon: '😺', text: 'smiley' },
	{ icon: '😸', text: 'smiley' },
	{ icon: '😹', text: 'smiley' },
	{ icon: '😻', text: 'smiley' },
	{ icon: '😼', text: 'smiley' },
	{ icon: '😽', text: 'smiley' },
	{ icon: '🙀', text: 'smiley' },
	{ icon: '😿', text: 'smiley' },
	{ icon: '😾', text: 'smiley' },

	{ icon: '☂️', text: 'umbrella סגול' },
	{ icon: '🌂️', text: 'umbrella 2' },
	{ icon: '🌂️', text: 'umbrella 2' },
	{ icon: '🦫', text: 'animals - beaver' },
	{ icon: '🪖', text: 'helmet general' },
	{ icon: '❤️‍🔥', text: 'heart on fire' },
	{ icon: '🫀', text: 'anatomic heart' },
	{ icon: '🪵', text: 'wood' },
	{ icon: '💂🏻‍♀️', text: 'guard london' },
	{ icon: '🪬', text: 'hamsa 5 general' },
	{ icon: '♣️', text: 'card club general' },
	{ icon: '🏞️', text: 'lake lakes' },
	{ icon: '🛟', text: 'life save water lake sea guard ring ים בריכה בריכות' },
	{ icon: '🫧', text: 'bouble boubles' },
];
